import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import imageCompression from "browser-image-compression";
import load from "../../assets/Images/loader.gif";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'js-cookie';



// const minDate = new Date().toISOString().split("T")[0];
// const maxDate = new Date(new Date().setDate(new Date().getDate() + 5)).toISOString().split("T")[0];

const optionAuthState = [
    { name: "Select State", code: "" },
    { name: "Andhra Pradesh", code: "100009" },
    { name: "Bihar", code: "100021" },
    { name: "Delhi", code: "100004" },
    { name: "Gujarat", code: "100015" },
    { name: "Haryana", code: "100008" },
    { name: "Jammu and Kashmir", code: "100011" },
    { name: "Karnataka", code: "100007" },
    { name: "Kerala", code: "100012" },
    { name: "Madhya Pradesh", code: "100014" },
    { name: "Maharashtra", code: "100002" },
    { name: "Odisha", code: "100026" },
    { name: "Other*", code: "100017" },
    { name: "Punjab", code: "100025" },
    { name: "Rajasthan", code: "100010" },
    { name: "Tamil Nadu", code: "100003" },
    { name: "Telangana", code: "100023" },
    { name: "Uttar Pradesh", code: "100006" },
    { name: "Uttarakhand", code: "100016" },
    { name: "West Bengal", code: "100013" },
    { name: "Goa", code: "100028" },
];

const optionAddressProof = [
    { value: "AADHAR", label: "Aadhar" },
    { value: "GST", label: "Address in GST Certificate" },
    { value: "Lease", label: "Lease Deed" },
    { value: "LOI", label: "LOI" },
    { value: "Deed", label: "Rent Deed" },
    { value: "Tax", label: "Tax Receipt" },
    { value: "Bill", label: "Utility Bill" },
]

const optionPhotoProof = [
    { value: "AADHAR", label: "Aadhar Card", required: true },
    { value: "LICENSE", label: "Driving license", required: true },
    { value: "GOVTIDCARD", label: "Govt. ID card", required: true },
    { value: "PASSPORT", label: "Passport", required: true },
    { value: "PAN", label: "Pan card", required: true },
    { value: "VOTERID", label: "Voter ID", required: true },
];

// const optionPoi = [
//     { value: "AADHAR", label: "Aadhar" },
//     { value: "LICENSE", label: "DL" },
//     { value: "PAN", label: "Pan" },
//     { value: "GOVTIDCARD", label: "Govt. Official ID" },
//     { value: "VOTERID", label: "Voter ID" },
// ]

const GstOpts = [
    // { value: "0", label: "Select Option" },
    { value: "569480000", label: "Yes" },
    { value: "569480001", label: "No" },
];

const DecOpts = [
    {
        value: " We don't have GST certificate as of now, we will notify Spectra once we get the same.",
        label: "We don't have GST certificate as of now, we will notify Spectra once we get the same."
    },
];

// const firmType = sessionStorage.getItem('firmtype')
// const firmType = "3";
// console.log("firmType", firmType)
// const cafSafNo = "CAF_H_103";//CAF_H_2495

const BroadbandCAFmangeNewDoc = () => {
    const style = {
        control: (base) => ({
            ...base,
            border: 0,
            // This line disable the blue border
            boxShadow: "none",
        }),
    };
    const [uploadedCafFile, setUploadedCafFile] = useState("");
    const [uploadedCoiFile, setUploadedCoiFile] = useState("");
    const [uploadedFormFile, setUploadedFormFile] = useState("");
    const [uploadedPanFile, setUploadedPanFile] = useState("");
    const [uploadedTanFile, setUploadedTanFile] = useState("");
    const [uploadedGstFile, setUploadedGstFile] = useState("");
    const [uploadedRegFile, setUploadedRegFile] = useState("");
    const [uploadedPoiFile, setUploadedPoiFile] = useState("");
    const [uploadedPhotoFile, setUploadedPhotoFile] = useState("");
    const [uploadedAddressFile, setUploadedAddressFile] = useState("");
    const [uploadedPurchseFile, setUploadedPurchseFile] = useState("");
    const [uploadedpartnerDeedFile, setUploadedpartnerDeedFile] = useState("");
    const [uploadedAuthFile, setUploadedAuthFile] = useState("");
    const [uploadedDeedFile, setUploadedDeedFile] = useState("");
    const [loading, setLoading] = useState(false);
    const [attachedFile, setAttachedFile] = useState([]);
    const [base64Strings, setBase64Strings] = useState([]);
    const [fileName, setFileName] = useState([]);
    const [selectAddressProof, setSelectAddressProof] = useState([]);
    const [selectPhotoProof, setSelectPhotoProof] = useState([]);
    const [selectPoi, setSelectPoi] = useState([]);
    const [coiDocVerify, setCoiDocVerify] = useState("");
    const [formDocVerify, setFormDocVerify] = useState("");
    const [purchaseDocVerify, setPurchaseDocVerify] = useState("");
    const [partnerDeedDocVerify, setPartnerDeedDocVerify] = useState("");
    const [cafReportDocVerify, setCafReportDocVerify] = useState("");
    const [panDocVerify, setPanDocVerify] = useState("");
    const [deedDocVerify, setDeedDocVerify] = useState("");
    const [gstDocVerify, setGstDocVerify] = useState("");
    const [tanDocVerify, setTanDocVerify] = useState("");
    const [registationDocVerify, setRegistationDocVerify] = useState("");
    const [poiDocVerify, setPoiDocVerify] = useState("");
    const [addressDocVerify, setAddressDocVerify] = useState("");
    const [photoDocVerify, setPhotoDocVerify] = useState("");
    const [authLetterDocVerify, setAuthLetterDocVerify] = useState("");
    const [selectGst, setSelectGst] = useState("");
    const [selectDec, setSelectDec] = useState();
    const [panCompany, setPanCompany] = useState("");
    const [panCompanyId, setPanCompanyId] = useState("");
    const [panGroup, setPanGroup] = useState("");
    const [panGroupId, setPanGroupId] = useState("");
    const [selectState, setSelectState] = useState("");

    const [autherName, setAutherName] = useState("");
    const [firmType, setFirmType] = useState("");

    const [cafDocData, setCafDocData] = useState({
        cafNo: "",
        coiNum: "",
        coiDoc: "",
        purchaseNum: "",
        purchaseDoc: "",
        partnerDeedNum: "",
        partnerDeedDoc: "",
        cafReportNum: "",
        cafReportDoc: "",
        panNum: "",
        panDoc: "",
        deedNum: "",
        deedDoc: "",
        gstNum: "",
        gstDoc: "",
        tanNum: "",
        registationNum: "",
        tanDoc: "",
        registationDoc: "",
        poiNum: "",
        poiDoc: "",
        authLetterNum: "",
        authLetterDoc: "",
        addressProofNum: "",
        photoProofNum: "",
        panDate: "",
        deedDate: "",
        poidate: "",
        coiDate: "",
        purchaseDate: "",
        partnerDeedDate: "",
        cafReportDate: "",
        gstDate: "",
        tanDate: "",
        registationDate: "",
        poiDate: "",
        authLetterDate: "",
        addressProofdate: "",
        addressProofDoc: "",
        photoProofdate: "",
        photoProofDoc: "",
        coiDocRej: "",
        purchaseDocRej: "",
        partnerDeedDocRej: "",
        cafReportDocRej: "",
        panDocRej: "",
        deedDocRej: "",
        tanDocRej: "",
        registationDocRej: "",
        gstDocRej: "",
        poiDocRej: "",
        addressDocRej: "",
        photoDocRej: "",
        authDocRej: "",
        formNum: "",
        formDocRej: "",
        formDoc: "",
        moaNum: "",
        moaDoc: "",
        moaDocRej: "",
        mcaNum: "",
        mcaDoc: "",
        mcaDocRej: "",
    });
    const [isCheckboxChecked, setIsCheckboxChecked] = useState({
        panCheck: false,
        deedCheck: false,
        coiCheck: false,
        purchaseCheck: false,
        partnerDeedCheck: false,
        cafReportCheck: false,
        gstCheck: false,
        tanCheck: false,
        registationCheck: false,
        poiCheck: false,
        addressProofCheck: false,
        photoProofCheck: false,
        authLetterCheck: false,
        formCheck: false,
        moaCheck: false,
        mcaCheck: false,

    });
    const [uploadedMoaFile, setUploadedMoaFile] = useState("");
    const [moaDocVerify, setMoaDocVerify] = useState("");
    const [uploadedMcaFile, setUploadedMcaFile] = useState("");
    const [mcaDocVerify, setMcaDocVerify] = useState("");


    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const cafSafNo = searchParams.get("CafId");

    const handleIsGst = (selectedOption) => {
        setSelectGst(selectedOption);
    };



    const handleChange = (e) => {
        // console.log(e.target.name, e.target.value);
        setCafDocData({ ...cafDocData, [e.target.name]: e.target.value });
    };

    // const handleBlur = async (event) => {
    //     console.log("Input blurred with value:", event.target.value);
    //     // alert("hjhjgs");
    //     try {
    //         const apiUrl = process.env.REACT_APP_API_URL;
    //         const requestPayload = {
    //             "Action": "getCompanyGroupByPAN",
    //             "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
    //             "panNumber": event.target.value,
    //             "customerName": "",
    //             "userName": sessionStorage.getItem('userName'),
    //             "password": sessionStorage.getItem('password')
    //         };
    //         const response = await fetch(apiUrl, {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json",
    //             },
    //             body: JSON.stringify(requestPayload),
    //         });

    //         const result = await response.json();
    //         console.log("API Response:", result);
    //         // console.log("result.Response.Company",result.Response.Company);

    //         setPanCompany(result.Response.Company);
    //         setPanCompanyId(result.Response.CompanyID);
    //         setPanGroup(result.Response.Group);
    //         setPanGroupId(result.Response.GroupID);
    //         if (result.Response.StatusCode == 200) {
    //             Swal.fire({
    //                 text: "Company and Group hierarchy exists in CRM, Continue?",
    //                 confirmButtonText:
    //                     '<span style="font-size: 15px;">OK</span>',
    //                 confirmButtonColor: "rgb(148,101,170)",
    //             }).then(async (result) => {
    //                 if (result.isConfirmed) {
    //                     try {
    //                         const apiUrl = process.env.REACT_APP_API_URL;
    //                         const requestPayload = {
    //                             "Action": "updateCompRelGroup",
    //                             "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
    //                             "CafNo": cafSafNo,
    //                             "Company": panCompany ? panCompany : "",
    //                             "CompanyID": panCompanyId ? panCompanyId : "",
    //                             "Group": panGroup ? panGroup : "",
    //                             "GroupID": panGroupId ? panGroupId : "",
    //                             "userName": sessionStorage.getItem('userName'),
    //                             "password": sessionStorage.getItem('password')
    //                         }
    //                         const response = await fetch(apiUrl, {
    //                             method: "POST",
    //                             headers: {
    //                                 "Content-Type": "application/json",
    //                             },
    //                             body: JSON.stringify(requestPayload),
    //                         });
    //                         console.log("panCompany", panCompany);

    //                         const result = await response.json();
    //                         console.log("API Response:", result);
    //                         if (result.Response.StatusCode == "200") {
    //                             toast.success(result.Response.Message, {
    //                                 position: toast.POSITION.BOTTOM_CENTER,
    //                                 autoClose: 1500,
    //                             });
    //                         }
    //                     } catch (error) {
    //                         console.error("Error in handleGstDeclaration API:", error);
    //                     }
    //                 }
    //             })
    //         }
    //         else {
    //             toast.warning(result.Response.Message, {
    //                 position: toast.POSITION.BOTTOM_CENTER,
    //                 autoClose: 2000,
    //             });
    //         }


    //     } catch (error) {
    //         console.error("Error in handleGstDeclaration API:", error);
    //     }
    // };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target; // Extract name and checked properties
        setIsCheckboxChecked((prevState) => ({
            ...prevState,
            [name]: checked, // Update the specific checkbox state
        }));

        if (checked) {
            toast.warning("Please Select Date", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }
    };


    const handleSelectAddressProof = (selectOption) => {
        setSelectAddressProof(selectOption);
    };

    const handleSelectPhotoProof = (selectOption) => {
        setSelectPhotoProof(selectOption);
    };

    const handleSelectPoi = (selectOption) => {
        setSelectPoi(selectOption);
    };


    const handleSubmitDoc = () => {
        setLoading(true); // Show loader

        setTimeout(() => {
            toast.success("Document uploaded Successfully", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }, 5000);

        setTimeout(() => {
            setLoading(false); // Hide loader before navigating
            navigate("/broadbandCaf");
        }, 6500); // Delay navigation slightly to ensure loader is turned off
    };


    const handleGstDeclaration = async (selectedOption) => {
        setSelectDec(selectedOption);

        try {
            setLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL_3;
            const requestPayload = {
                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                "Action": "uploadDocDigitalCaf",
                "password": sessionStorage.getItem('password'),
                "userName": sessionStorage.getItem('userName'),
                "CafSafNo": cafSafNo,
                "data": [
                    {
                        "DocumentName": "GST Number",
                        "DocumentNumber": "",
                        "PendingDocSubmitOn": "",
                        "fileNameWithExtension": "",
                        "fileContent": "",
                        "IsGSTapplicable": selectGst.label ? selectGst.label : "",
                        "GSTDeclaration": selectedOption.label ? selectedOption.label : ""
                    }
                ]
            };

            // console.log("Sending request:", requestPayload);

            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestPayload),
            });

            const result = await response.json();
            // console.log("API Response:", result);

        } catch (error) {
            console.error("Error in handleGstDeclaration API:", error);
        } finally {
            setLoading(false);
            window.location.reload();
        }
    };




    const uploadDocDigitalCaf = async (payload) => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL_3;
            let request = {
                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                "Action": "uploadDocDigitalCaf",
                "password": sessionStorage.getItem('password'),
                "userName": sessionStorage.getItem('userName'),
                "CafSafNo": cafSafNo,
            };
            // Construct the data array conditionally
            let data = [
                {
                    "DocumentName": payload.DocumentName,
                    "DocumentNumber": payload.DocumentNumber,
                    "PendingDocSubmitOn": "", // "2024-11-21"
                    "fileNameWithExtension": payload.fileNameWithExtension,
                    "fileContent": payload.fileContent,
                    "IsGSTapplicable": "",
                    "GSTDeclaration": "",
                }
            ];

            if (selectGst.label == "Yes") {
                // data[0]["IsGSTapplicable"] = selectGst.label;
                // data[0]["GSTDeclaration"] = "";
                data = [
                    {
                        "DocumentName": payload.DocumentName,
                        "DocumentNumber": payload.DocumentNumber,
                        "PendingDocSubmitOn": "", // "2024-11-21"
                        "fileNameWithExtension": payload.fileNameWithExtension,
                        "fileContent": payload.fileContent,
                        "IsGSTapplicable": payload.IsGSTapplicable,
                        "GSTDeclaration": "",
                    }
                ];
            }

            request["data"] = data;
            // console.log("request: ", request);
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(request),
            });
            const result = await response.json();
            // console.log("uploadDocDigitalCaf: ", result);
            let docNameStr = payload.DocumentName.replace(/\s+/g, '');
            console.log("docNameStr", docNameStr);
            // console.log("result.Response.StatusCode", result.Response.StatusCode);
            if (result.Response.StatusCode == 200) {
                toast.success(result.Response.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };


    const handleFileUpload = async (event, docName) => {
        const selectedFile = event.target.files[0];
        // console.log(cafDocData.coiNum, docName);
        // console.log("selectedFile.name", selectedFile.name);
        const fileExtension = `.${selectedFile?.name.split('.').pop()}`;
        // console.log("fileExtension", fileExtension);
        // let fileNameWithExtension = selectedFile.name;
        let fileNameWithExtension;
        let documentName;
        let documentNumber;

        // Regular expressions for validations
        const regexPAN = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
        const regexTAN = /^[A-Z]{4}[0-9]{5}[A-Z]{1}$/;
        const regexGST = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9A-Z]{3}$/;
        const stateGSTMapping = {
            "Jammu & Kashmir": "01",
            "Himachal Pradesh": "02",
            "Punjab": "03",
            "Chandigarh": "04",
            "Uttarakhand": "05",
            "Haryana": "06",
            "Delhi": "07",
            "Rajasthan": "08",
            "Uttar Pradesh": "09",
            "Bihar": "10",
            "Sikkim": "11",
            "Arunachal Pradesh": "12",
            "Nagaland": "13",
            "Manipur": "14",
            "Mizoram": "15",
            "Tripura": "16",
            "Meghalaya": "17",
            "Assam": "18",
            "West Bengal": "19",
            "Jharkhand": "20",
            "Odisha": "21",
            "Chhattisgarh": "22",
            "Madhya Pradesh": "23",
            "Gujarat": "24",
            "Daman & Diu": "25",
            "Dadra & Nagar Haveli": "26",
            "Maharashtra": "27",
            "Andhra Pradesh": "28",  // Andhra Pradesh may also use '37' in certain cases.
            "Karnataka": "29",
            "Goa": "30",
            "Lakshadweep": "31",
            "Kerala": "32",
            "Tamil Nadu": "33",
            "Puducherry": "34",
            "Andaman & Nicobar Islands": "35",
            "Telangana": "36",
            "Ladakh": "38",
            "Others Territory": "97",
            "Center Jurisdiction": "99"
        };

        switch (docName) {
            case "authorisationLetter":
                documentName = "Authorisation letter";
                documentNumber = cafDocData.authLetterNum;
                fileNameWithExtension = `Authorisation${fileExtension}`;
                setUploadedAuthFile(fileNameWithExtension);
                break;
            case "deedNumber":
                documentName = "Trust Deed";
                documentNumber = cafDocData.deedNum;
                fileNameWithExtension = `DEED${fileExtension}`;
                setUploadedDeedFile(fileNameWithExtension);
                break;
            case "poi":
                documentName = "POI";
                documentNumber = cafDocData.poiNum;
                // fileNameWithExtension = `Poi${fileExtension}`
                if (selectPoi?.value) {
                    fileNameWithExtension = `${selectPoi.value}${fileExtension}`;
                } else {
                    fileNameWithExtension = `POI${fileExtension}`
                }
                setUploadedPoiFile(fileNameWithExtension);
                break;
            case "addressProof":
                documentName = "Address Proof";
                documentNumber = cafDocData.addressProofNum;
                if (selectAddressProof?.value) {
                    fileNameWithExtension = `${selectAddressProof.value}${fileExtension}`;
                } else {
                    fileNameWithExtension = `Address${fileExtension}`
                }
                setUploadedAddressFile(fileNameWithExtension);
                break;
            case "photoProof":
                documentName = "Photo Proof";
                documentNumber = cafDocData.photoProofNum;
                if (selectPhotoProof?.value) {
                    fileNameWithExtension = `${selectPhotoProof.value}${fileExtension}`;
                } else {
                    fileNameWithExtension = `Photo${fileExtension}`
                }
                // fileNameWithExtension = `Photo${fileExtension}`
                setUploadedPhotoFile(fileNameWithExtension);
                break;
            case "gstNumber":
                // --- Begin GST Validation ---
                if (!cafDocData.gstNum) {
                    toast.error("GST Number is required", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 });
                    event.target.value = "";
                    return;
                }
                if (!regexGST.test(cafDocData.gstNum)) {
                    toast.error(
                        "Please enter GST in CAPITAL Letters and correct format (e.g., 12ABCDE1234A1A1 or 12ABCDE1234A1AA)",
                        { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }
                    );
                    event.target.value = "";
                    return;
                }
                // console.log("selectState", selectState);

                if (selectState && selectState.label && stateGSTMapping[selectState.label]) {
                    const expectedGSTPrefix = stateGSTMapping[selectState.label];
                    const gstPrefix = cafDocData.gstNum.slice(0, 2); // Extract first two digits.
                    if (gstPrefix !== expectedGSTPrefix) {
                        toast.error(
                            `GST number does not match the selected state's GST code. Expected prefix: ${expectedGSTPrefix}`,
                            { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }
                        );
                        event.target.value = "";
                        return;
                    }
                }
                // --- End GST Validation ---
                documentName = "GST Number";
                documentNumber = cafDocData.gstNum;
                fileNameWithExtension = `GST${fileExtension}`
                setUploadedGstFile(fileNameWithExtension);
                break;
            case "panNumber":
                // --- Begin PAN Validation ---
                if (!cafDocData.panNum) {
                    toast.error("PAN Number is required", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 });
                    event.target.value = "";
                    return;
                }
                if (!regexPAN.test(cafDocData.panNum)) {
                    toast.error(
                        "Please enter PAN in CAPITAL Letters and correct format (ABCDE1234A)",
                        { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }
                    );
                    event.target.value = "";
                    return;
                }
                // --- End PAN Validation ---
                documentName = "Company PAN Number";
                documentNumber = cafDocData.panNum;
                fileNameWithExtension = `PAN${fileExtension}`;
                setUploadedPanFile(fileNameWithExtension);
                break;
            case "tanNumber":
                // --- Begin TAN Validation ---
                if (!cafDocData.tanNum) {
                    toast.error("TAN Number is required", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 });
                    event.target.value = "";
                    return;
                }
                if (!regexTAN.test(cafDocData.tanNum)) {
                    toast.error(
                        "Please enter TAN in CAPITAL Letters and correct format (ABCD12345A)",
                        { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }
                    );
                    event.target.value = "";
                    return;
                }
                // --- End TAN Validation ---
                documentName = "TAN Number";
                documentNumber = cafDocData.tanNum;
                fileNameWithExtension = `TAN${fileExtension}`;
                setUploadedTanFile(fileNameWithExtension);
                break;
            case "registationNumber":
                documentName = "Registation Certificate";
                documentNumber = cafDocData.registationNum;
                fileNameWithExtension = `RegDoc${fileExtension}`;
                setUploadedRegFile(fileNameWithExtension);
                break;
            case "FormC":
                documentName = "Form C";
                documentNumber = cafDocData.formNum;
                fileNameWithExtension = `FormC${fileExtension}`;
                setUploadedFormFile(fileNameWithExtension)
                break;
            case "coi":
                documentName = "COI";
                documentNumber = cafDocData.coiNum;
                fileNameWithExtension = `COI${fileExtension}`;
                setUploadedCoiFile(fileNameWithExtension)
                break;
            case "po":
                documentName = "PO";
                documentNumber = cafDocData.purchaseNum;
                fileNameWithExtension = `PO${fileExtension}`
                setUploadedPurchseFile(fileNameWithExtension);
                break;

            case "pd":
                documentName = "PD";
                documentNumber = cafDocData.partnerDeedNum;
                fileNameWithExtension = `PD${fileExtension}`
                setUploadedpartnerDeedFile(fileNameWithExtension);
                break;

            case "cafReport":
                documentName = "CAF Report";
                documentNumber = cafDocData.cafReportNum;
                fileNameWithExtension = `CAFReport${fileExtension}`;
                setUploadedCafFile(fileNameWithExtension);
                break;
            case "moa":
                documentName = "MOA";
                documentNumber = cafDocData.moaNum;
                fileNameWithExtension = `MOA${fileExtension}`;
                setUploadedMoaFile(fileNameWithExtension)
                break;
            case "mca":
                documentName = "MCA";
                documentNumber = cafDocData.mcaNum;
                fileNameWithExtension = `MCA${fileExtension}`;
                setUploadedMcaFile(fileNameWithExtension)
                break;
        }

        // Check if the selected file is an image or a PDF
        const isImage = selectedFile.type.startsWith("image/");
        const isPdf = selectedFile.type === "application/pdf";

        // Handle image files
        if (isImage) {
            const options = {
                maxSizeMB: 1, // Maximum file size in MB
                maxWidthOrHeight: 1920, // Max width or height
                useWebWorker: true, // Use web worker for faster compression
            };

            try {
                const compressedFile = await imageCompression(selectedFile, options);
                setAttachedFile(compressedFile.name);

                const reader = new FileReader();
                // console.log("docName", docName);

                reader.onloadend = async () => {
                    let base64String = reader.result;
                    if (base64String) {
                        const prefixIndex = base64String.indexOf(";base64,");
                        if (prefixIndex !== -1) {
                            base64String = base64String.slice(prefixIndex + 8); // +8 to remove the prefix including ";base64,"
                        }
                        base64String = base64String.replace(/^"|"$/g, "");
                        setBase64Strings(base64String);
                        // await handleDocumentSave(base64String, selectedFile.name);
                        if (selectGst.label == "Yes") {
                            await uploadDocDigitalCaf({
                                "CafNo": cafDocData.cafNo,
                                "DocumentName": documentName,
                                "DocumentNumber": documentNumber,
                                "PendingDocSubmitOn": "",  // 2024-11-21
                                "fileNameWithExtension": fileNameWithExtension,
                                "fileContent": base64String,
                                "IsGSTapplicable": docName == "gstNumber" ? selectGst.label : "",
                                "GSTDeclaration": "",
                            });
                        } else {
                            await uploadDocDigitalCaf({
                                "CafNo": cafDocData.cafNo,
                                "DocumentName": documentName,
                                "DocumentNumber": documentNumber,
                                "PendingDocSubmitOn": "",  // 2024-11-21
                                "fileNameWithExtension": fileNameWithExtension,
                                "fileContent": base64String,
                                "IsGSTapplicable": "",
                                "GSTDeclaration": "",
                            });
                        }
                    } else {
                        console.log("Base64 string is empty or undefined");
                    }
                };
                reader.readAsDataURL(compressedFile);
                // console.log([compressedFile.name]);

                setFileName([compressedFile.name]);
            } catch (error) {
                console.error("Error during image compression:", error);
            }

            // Handle PDF files
        } else if (isPdf) {
            setAttachedFile(selectedFile.name);
            const reader = new FileReader();
            reader.onloadend = async () => {
                let base64String = reader.result;
                if (base64String) {
                    const prefixIndex = base64String.indexOf(";base64,");
                    if (prefixIndex !== -1) {
                        base64String = base64String.slice(prefixIndex + 8); // +8 to remove the prefix including ";base64,"
                    }
                    base64String = base64String.replace(/^"|"$/g, "");
                    // console.log("base64String", base64String);

                    setBase64Strings(base64String);

                    if (selectGst.label == "Yes") {
                        await uploadDocDigitalCaf({
                            "CafNo": cafDocData.cafNo,
                            "DocumentName": documentName,
                            "DocumentNumber": documentNumber,
                            "PendingDocSubmitOn": "",  // 2024-11-21
                            "fileNameWithExtension": fileNameWithExtension,
                            "fileContent": base64String,
                            "IsGSTapplicable": docName == "gstNumber" ? selectGst.label : "",
                            "GSTDeclaration": "",
                        });
                    } else {
                        await uploadDocDigitalCaf({
                            "CafNo": cafDocData.cafNo,
                            "DocumentName": documentName,
                            "DocumentNumber": documentNumber,
                            "PendingDocSubmitOn": "",  // 2024-11-21
                            "fileNameWithExtension": fileNameWithExtension,
                            "fileContent": base64String,
                            "IsGSTapplicable": "",
                            "GSTDeclaration": "",
                        });
                    }
                } else {
                    console.log("Base64 string is empty or undefined");
                }
            };

            reader.readAsDataURL(selectedFile);
            // console.log([selectedFile]);
            setFileName([selectedFile.name]);
        } else {
            console.error("Unsupported file type");
        }
        event.target.value = "";
    };

    // const formatDateForInput = (date) => {
    //     if (!date) return ""; // If the date is empty, return an empty string
    //     const [year, day, month] = date.split("-");
    //     return `${year}-${month}-${day}`; // Rearrange to yyyy-MM-dd
    // };

    const [selectedCoiDate, setSelectedCoiDate] = useState(
        cafDocData.coiDate ? new Date(cafDocData.coiDate) : null
    );
    const [selectedFormDate, setSelectedFormDate] = useState(
        cafDocData.formDate ? new Date(cafDocData.formDate) : null
    );
    const [selectedDeedDate, setSelectedDeedDate] = useState(
        cafDocData.deedDate ? new Date(cafDocData.deedDate) : null
    );
    const [selectedPartnerDeedDate, setSelectedPartnerDeedDate] = useState(
        cafDocData.partnerDeedDate ? new Date(cafDocData.partnerDeedDate) : null
    );
    const [selectedPanDate, setSelectedPanDate] = useState(
        cafDocData.panDate ? new Date(cafDocData.panDate) : null
    );
    const [selectedGstDate, setSelectedGstDate] = useState(
        cafDocData.gstDate ? new Date(cafDocData.gstDate) : null
    );
    const [selectedTanDate, setSelectedTanDate] = useState(
        cafDocData.tanDate ? new Date(cafDocData.tanDate) : null
    );
    const [selectedRegDate, setSelectedRegDate] = useState(
        cafDocData.registationDate ? new Date(cafDocData.registationDate) : null
    );
    const [selectedPhotoProofDate, setSelectedPhotoProofDate] = useState(
        cafDocData.photoProofdate ? new Date(cafDocData.photoProofdate) : null
    );
    const [selectedAuthDate, setSelectedAuthDate] = useState(
        cafDocData.authLetterDate ? new Date(cafDocData.authLetterDate) : null
    );
    const [selectedAddressProofDate, setSelectedAddressProofDate] = useState(
        cafDocData.addressProofdate ? new Date(cafDocData.addressProofdate) : null
    );
    const [selectedMoaDate, setSelectedMoaDate] = useState(
        cafDocData.moaDate ? new Date(cafDocData.moaDate) : null
    );

    const [selectedMcaDate, setSelectedMcaDate] = useState(
        cafDocData.mcaDate ? new Date(cafDocData.mcaDate) : null
    );
    const isWeekday = (date) => {
        // const day = date.getDay();
        // return day !== 0 && day !== 6; // Disable Saturdays and Sundays

        const today = new Date();
        let count = 0;
        let tempDate = new Date(today);
        const selectableDates = [];

        // Loop to get the next 5 valid weekdays (including today)
        while (count < 5) {
            const day = tempDate.getDay();
            if (day !== 0 && day !== 6) { // Skip Sundays (0) & Saturdays (6)
                selectableDates.push(new Date(tempDate)); // Store valid date
                count++;
            }
            tempDate.setDate(tempDate.getDate() + 1); // Move to next day
        }

        return selectableDates.some(
            (validDate) => validDate.toDateString() === date.toDateString()
        );
    };


    const handleDateChange = async (e, docName) => {
        // const selectedDate = e.target.value; // Get the selected date

        const inputDate = e.target.value; // Input date is in yyyy-MM-dd format
        const [year, month, day] = inputDate.split("-");
        // const formattedDate = `${year}-${day}-${month}`; // Convert to yyyy-dd-mm
        const formattedDate = `${year}-${month}-${day}`;
        // console.log("formattedDate", formattedDate);


        setCafDocData((prevState) => ({
            ...prevState,
            [`${docName}Date`]: formattedDate,
        }));

        let documentName;
        switch (docName) {
            case "authorisationLetter":
                documentName = "Authorisation letter";
                break;
            case "gstNumber":
                documentName = "GST Number";
                break;
            case "panNumber":
                documentName = "Company PAN Number";
                break;
            case "deedNumber":
                documentName = "Trust Deed";
                break;
            case "tanNumber":
                documentName = "TAN Number";
                break;
            case "registationNumber":
                documentName = "Registation Certificate";
                break;
            case "coi":
                documentName = "COI";
                break;
            case "poi":
                documentName = "Poi";
                break;
            case "addressProof":
                documentName = "Address Proof";
                break;
            case "photoProof":
                documentName = "Photo Proof";
                break;
            case "po":
                documentName = "po";
                break;
            case "pd":
                documentName = "PD";
                break;
            case "FormC":
                documentName = "Form C";
                break;
            case "moa":
                documentName = "MOA";
                break;
            case "mca":
                documentName = "MCA";
                break;
        }

        try {
            const apiUrl = process.env.REACT_APP_API_URL_3;
            const apiPayload = {
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                Action: "uploadDocDigitalCaf",
                password: sessionStorage.getItem('password'),
                userName: sessionStorage.getItem('userName'),
                CafSafNo: cafSafNo,
            };
            let data = [
                {
                    DocumentName: documentName,
                    DocumentNumber: "",
                    PendingDocSubmitOn: `${formattedDate}`,
                    fileNameWithExtension: "",
                    fileContent: "",
                    IsGSTapplicable: "",
                    GSTDeclaration: ""
                },
            ];
            if (selectGst.label == "Yes") {
                // data[0]["IsGSTapplicable"] = selectGst.label;
                // data[0]["GSTDeclaration"] = "";
                data = [
                    {
                        DocumentName: documentName,
                        DocumentNumber: "",
                        PendingDocSubmitOn: `${formattedDate}`,
                        fileNameWithExtension: "",
                        fileContent: "",
                        IsGSTapplicable: docName == "gstNumber" ? selectGst.label : "",
                        GSTDeclaration: ""
                    },
                ];
            }

            apiPayload["data"] = data;
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(apiPayload),
            });
            const result = await response.json();

            if (result.Response.StatusCode == 200) {
                toast.success("Documents Submission Date Updated", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                // window.location.reload()
            }

        } catch (error) {
            console.error("Error calling API:", error);
        }


    };



    const navigate = useNavigate();
    const redirectBroadbandCafformPage = () => {
        Swal.fire({
            html: '<div style="font-size: 15px;">Do you want to go back to the previous screen?</div>',
            showCancelButton: true,
            confirmButtonText:
                '<span style="font-size: 12px;color:rgb(148,101,170);">YES</span>',
            cancelButtonText:
                '<span style="font-size: 12px;color:rgb(148,101,170);">NO</span>',
            confirmButtonColor: "white",
            cancelButtonColor: "white",
            customClass: {
                popup: "custom-popup",
                confirmButton: "custom-confirm-button",
                cancelButton: "custom-cancel-button",
            },
        }).then((result) => {
            if (result.isConfirmed) {
                // navigate(`/broadbandCAFmanageForm`);
                navigate(`/broadbandCAFmanageForm?CafId=${cafSafNo}`);
                Cookies.remove('firmtype');
            } else {
                navigate(`/broadbandCAFmangeNewDoc`);
            }
        });
    };







    useEffect(() => {
        const fetchData = async () => {
            try {
                const apiUrl = process.env.REACT_APP_API_URL_3;
                const requestData = {
                    "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    "Action": "getDocDigitalCafSaf",
                    "userName": sessionStorage.getItem('userName'),
                    "password": sessionStorage.getItem('password'),
                    "CafSafNo": cafSafNo
                };

                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestData),
                });
                const data = await response.json();
                // updateRequiredDoc(data);
                // Check if Response and data are available
                if (data?.Response?.data) {
                    const docs = data.Response.data;

                    // Create a map of document name to data
                    const documentMap = docs.reduce((acc, doc) => {
                        acc[doc.DocumentName] = doc;
                        return acc;
                    }, {});
                    // console.log("data.Response.CafSafNo", data.Response.CafSafNo)
                    // Set data dynamically using document names (like "COI", "PAN", etc.)
                    setCafDocData({
                        cafNo: data.Response.CafSafNo,
                        addressProofNum: documentMap["Address Proof"]?.DocumentNumber || "",
                        addressProofDoc: documentMap["Address Proof"]?.fileNameWithExtension || "",
                        addressDocRej: documentMap["Address Proof"]?.SubRejectReason || "",
                        photoProofNum: documentMap["Photo Proof"]?.DocumentNumber || "",
                        photoProofDoc: documentMap["Photo Proof"]?.fileNameWithExtension || "",
                        photoDocRej: documentMap["Photo Proof"]?.SubRejectReason || "",
                        authLetterNum: documentMap["Authorisation letter"]?.DocumentNumber || "",
                        authLetterDoc: documentMap["Authorisation letter"]?.fileNameWithExtension || "",
                        authDocRej: documentMap["Authorisation letter"]?.SubRejectReason || "",
                        coiNum: documentMap["COI"]?.DocumentNumber || "",
                        coiDoc: documentMap["COI"]?.fileNameWithExtension || "",
                        coiDocRej: documentMap["COI"]?.SubRejectReason || "",
                        moaNum: documentMap["MOA"]?.DocumentNumber || "",
                        moaDoc: documentMap["MOA"]?.fileNameWithExtension || "",
                        moaDocRej: documentMap["MOA"]?.SubRejectReason || "",
                        mcaNum: documentMap["MCA"]?.DocumentNumber || "",
                        mcaDoc: documentMap["MCA"]?.fileNameWithExtension || "",
                        mcaDocRej: documentMap["MCA"]?.SubRejectReason || "",
                        purchaseNum: documentMap["PO"]?.DocumentNumber || "",
                        purchaseDoc: documentMap["PO"]?.fileNameWithExtension || "",
                        purchaseDocRej: documentMap["PO"]?.SubRejectReason || "",
                        partnerDeedNum: documentMap["PD"]?.DocumentNumber || "",
                        partnerDeedDoc: documentMap["PD"]?.fileNameWithExtension || "",
                        partnerDeedDocRej: documentMap["PD"]?.SubRejectReason || "",
                        cafReportNum: documentMap["CAF Report"]?.DocumentNumber || "",
                        cafReportDoc: documentMap["CAF Report"]?.fileNameWithExtension || "",
                        cafReportDocRej: documentMap["CAF Report"]?.SubRejectReason || "",
                        panNum: documentMap["Company PAN Number"]?.DocumentNumber || "",
                        panDoc: documentMap["Company PAN Number"]?.fileNameWithExtension || "",
                        panDocRej: documentMap["Company PAN Number"]?.SubRejectReason || "",
                        deedNum: documentMap["Trust Deed"]?.DocumentNumber || "",
                        deedDoc: documentMap["Trust Deed"]?.fileNameWithExtension || "",
                        deedDocRej: documentMap["Trust Deed"]?.SubRejectReason || "",
                        gstNum: documentMap["GST Number"]?.DocumentNumber || "",
                        gstDoc: documentMap["GST Number"]?.fileNameWithExtension || "",
                        gstDocRej: documentMap["GST Number"]?.SubRejectReason || "",
                        poiNum: documentMap["POI of Authorized Signatory"]?.DocumentNumber || "",
                        poiDoc: documentMap["POI of Authorized Signatory"]?.fileNameWithExtension || "",
                        poiDocRej: documentMap["POI of Authorized Signatory"]?.SubRejectReason || "",
                        tanNum: documentMap["TAN Number"]?.DocumentNumber || "",
                        tanDoc: documentMap["TAN Number"]?.fileNameWithExtension || "",
                        tanDocRej: documentMap["TAN Number"]?.SubRejectReason || "",
                        registationNum: documentMap["Registation Certificate"]?.DocumentNumber || "",
                        registationDoc: documentMap["Registation Certificate"]?.fileNameWithExtension || "",
                        registationDocRej: documentMap["Registation Certificate"]?.SubRejectReason || "",
                        formNum: documentMap["Form C"]?.DocumentNumber || "",
                        formDocRej: documentMap["Form C"]?.fileNameWithExtension || "",
                        formDoc: documentMap["Form C"]?.SubRejectReason || "",


                    });
                    // console.log("ApprovalStatus", documentMap["COI"]?.DocumentSubmittedWithin);
                    // const coiDateValue = documentMap["COI"]?.DocumentSubmittedWithin;
                    // const PDdateValue = documentMap["PD"]?.DocumentSubmittedWithin;
                    // const PanDateValue = documentMap["Company PAN Number"]?.DocumentSubmittedWithin;
                    // const GstDateValue = documentMap["GST Number"]?.DocumentSubmittedWithin;
                    // const TanDateValue = documentMap["TAN Number"]?.DocumentSubmittedWithin;
                    // const RegDateValue = documentMap["Registation Certificate"]?.DocumentSubmittedWithin;
                    // const photoDateValue = documentMap["Photo Proof"]?.DocumentSubmittedWithin;
                    // const authDateValue = documentMap["Authorisation letter"]?.DocumentSubmittedWithin;
                    // const addressDateValue = documentMap["Address Proof"]?.DocumentSubmittedWithin;
                    const parseValidDate = (dateString) => {
                        if (!dateString) return null; // Handle empty or undefined values
                        // console.log("Parsing Date:", dateString);
                        // Try direct parsing
                        let parsedDate = new Date(dateString);
                        if (!isNaN(parsedDate.getTime())) return parsedDate;
                        // Handle possible backend format variations
                        const dateParts = dateString.split(/[-/]/); // Supports "yyyy-mm-dd", "dd-mm-yyyy"
                        if (dateParts.length === 3) {
                            let [year, month, day] = dateParts.map(Number);
                            // If the year is not in the correct position, swap
                            if (year < 1000) [day, month, year] = [year, month, day];
                            parsedDate = new Date(year, month - 1, day);
                            if (!isNaN(parsedDate.getTime())) return parsedDate;
                        }
                        console.error("Invalid date format:", dateString);
                        return null; // Return null if date is still invalid
                    };
                    setSelectedCoiDate(parseValidDate(documentMap["COI"]?.DocumentSubmittedWithin));
                    setSelectedMoaDate(parseValidDate(documentMap["MOA"]?.DocumentSubmittedWithin));
                    setSelectedMcaDate(parseValidDate(documentMap["MCA"]?.DocumentSubmittedWithin));
                    setSelectedDeedDate(parseValidDate(documentMap["Trust Deed"]?.DocumentSubmittedWithin));
                    setSelectedPartnerDeedDate(parseValidDate(documentMap["PD"]?.DocumentSubmittedWithin));
                    setSelectedPanDate(parseValidDate(documentMap["Company PAN Number"]?.DocumentSubmittedWithin));
                    setSelectedGstDate(parseValidDate(documentMap["GST Number"]?.DocumentSubmittedWithin));
                    setSelectedTanDate(parseValidDate(documentMap["TAN Number"]?.DocumentSubmittedWithin));
                    setSelectedRegDate(parseValidDate(documentMap["Registation Certificate"]?.DocumentSubmittedWithin));
                    setSelectedPhotoProofDate(parseValidDate(documentMap["Photo Proof"]?.DocumentSubmittedWithin));
                    setSelectedAuthDate(parseValidDate(documentMap["Authorisation letter"]?.DocumentSubmittedWithin));
                    setSelectedAddressProofDate(parseValidDate(documentMap["Address Proof"]?.DocumentSubmittedWithin));
                    setSelectedFormDate(parseValidDate(documentMap["Form C"]?.DocumentSubmittedWithin));
                    setSelectGst({
                        value: documentMap["GST Number"]?.IsGSTapplicable,
                        label: documentMap["GST Number"]?.IsGSTapplicable,
                    });
                    setSelectDec({
                        value: documentMap["GST Number"]?.GSTDeclaration,
                        label: documentMap["GST Number"]?.GSTDeclaration,
                    })
                    // Set verification statuses dynamically
                    setAddressDocVerify(documentMap["Address Proof"]?.ApprovalStatus || "");
                    setPhotoDocVerify(documentMap["Photo Proof"]?.ApprovalStatus || "");
                    setAuthLetterDocVerify(documentMap["Authorisation letter"]?.ApprovalStatus || "");
                    setCoiDocVerify(documentMap["COI"]?.ApprovalStatus || "");
                    setMoaDocVerify(documentMap["MOA"]?.ApprovalStatus || "");
                    setMcaDocVerify(documentMap["MCA"]?.ApprovalStatus || "");
                    setPurchaseDocVerify(documentMap["PO"]?.ApprovalStatus || "")
                    setPartnerDeedDocVerify(documentMap["PD"]?.ApprovalStatus || "");
                    setCafReportDocVerify(documentMap["CAF Report"]?.ApprovalStatus || "")
                    setPanDocVerify(documentMap["Company PAN Number"]?.ApprovalStatus || "");
                    setDeedDocVerify(documentMap["Trust Deed"]?.ApprovalStatus || "");
                    setGstDocVerify(documentMap["GST Number"]?.ApprovalStatus || "");
                    setPoiDocVerify(documentMap["POI of Authorized Signatory"]?.ApprovalStatus || "");
                    setTanDocVerify(documentMap["TAN Number"]?.ApprovalStatus || "");
                    setRegistationDocVerify(documentMap["Registation Certificate"]?.ApprovalStatus || "");
                    setFormDocVerify(documentMap["Form C"]?.ApprovalStatus || "");
                } else {
                    console.error("No document data found in the response.");
                }
            } catch (error) {
                console.error("Error fetching data:", error.message);
            }
        };

        fetchData();
    }, []);


    const handleDeleteDoc = async (e, docName, documentFileName) => {
        e.stopPropagation(); // Prevent any unwanted event bubbling

        let documentName;

        switch (docName) {
            case "coi":
                documentName = "COI";
                documentFileName = cafDocData?.coiDoc
                break;
            case "gstNumber":
                documentName = "GST Number";
                documentFileName = cafDocData?.gstDoc
                break;
            case "panNumber":
                documentName = "Company PAN Number";
                documentFileName = cafDocData?.panDoc
                break;
            case "deedNumber":
                documentName = "Trust Deed";
                documentFileName = cafDocData?.deedDoc
                break;
            case "tanNumber":
                documentName = "TAN Number";
                documentFileName = cafDocData?.tanDoc
                break;
            case "registationNumber":
                documentName = "Registation Certificate";
                documentFileName = cafDocData?.registationDoc
                break;
            case "poi":
                documentName = "Poi";
                documentFileName = cafDocData?.poiDoc
                break;
            case "addressProof":
                documentName = "Address Proof";
                documentFileName = cafDocData?.addressProofDoc
                break;
            case "photoProof":
                documentName = "Photo Proof";
                documentFileName = cafDocData?.photoProofDoc
                break;
            case "po":
                documentName = "PO";
                documentFileName = cafDocData?.poDoc
                break;
            case "pd":
                documentName = "PD";
                documentFileName = cafDocData?.partnerDeedDoc
                break;
            case "FormC":
                documentName = "Form C";
                documentFileName = cafDocData?.formDoc
                break;
            case "networkDiagram":
                documentName = "Network Diagram";
                documentFileName = cafDocData?.networkDoc
                break;
            case "authorisationLetter":
                documentName = "Authorisation letter";
                documentFileName = cafDocData?.authLetterDoc
                break;
            case "moa":
                documentName = "MOA";
                documentFileName = cafDocData?.moaDoc
                break;
            case "mca":
                documentName = "MCA";
                documentFileName = cafDocData?.mcaDoc
                break;
            default:
                console.error("Invalid document name");
                return;
        }
        try {
            const apiUrl = process.env.REACT_APP_API_URL;

            const payload = {
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                Action: "deleteKYCAttachmentFromDoc",
                password: sessionStorage.getItem('password'),
                userName: sessionStorage.getItem('userName'),
                CafSafNo: cafSafNo,
                data: [
                    {
                        DocumentName: documentName,
                        fileNameWithExtension: documentFileName
                    }
                ]
            };
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            const result = await response.json();

            if (result?.Response?.StatusCode === 200) {
                console.log(`${documentName} deleted successfully`);
                toast.success(`${documentName} deleted successfully!`, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            } else {
                console.error("Failed to delete document", result);
                toast.error("Failed to delete document", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }
        } catch (error) {
            console.error("Error deleting document:", error);
            toast.error("Error deleting document", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }
    };


    useEffect(() => {
        const fetchBussinessCAF = async () => {
            try {
                const apiUrl = process.env.REACT_APP_API_URL_2;

                const requestData = {
                    Action: "getCafDigiHome",
                    Authkey: "AdgT6SnjAkeLqlkE4",
                    CAFId: cafSafNo,
                    password: sessionStorage.getItem("password"),
                    userName: sessionStorage.getItem("userName"),
                };
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestData),
                });
                const result = await response.json();
                if (result.Status === "Success" && result.Response) {
                    // console.log("result.Response", result.Response);

                    const { accountDetail, paymentDetail, documentRequired, cafDetail, authorSigDetails } = result.Response;
                    const filterState = optionAuthState.find(
                        (item) => item.code === String(accountDetail?.State)
                    ).name;
                    // console.log("filterAuthState", optionAuthState);

                    setSelectState({
                        label: filterState,
                        value: accountDetail?.State,
                    });

                    setAutherName(result.Response.authorSigDetails.AuthName)
                    setFirmType(result.Response.documentRequired.FirmType)
                }

            } catch (error) {
                console.error("Error fetching data:", error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchBussinessCAF();
    }, [cafSafNo]);





    const handleGenerateOTPforSel = async () => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL_3;
            const requestData = {
                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                "Action": "generateOTPforSel",
                "userName": sessionStorage.getItem('userName'),
                "password": sessionStorage.getItem('password'),
                "GenerateOTP": "Yes"
            }
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    // "token": "e7e916c2e449f6306b27dea2fb2dde46",
                },
                body: JSON.stringify(requestData),
            });
            const data = await response.json();
            // console.log("response", data);


        } catch (error) {
            console.error("Error fetching data:", error.message);
        }
    }

    const handleResendEmailToCust = async () => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL_3;
            const requestData = {
                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                "Action": "resendEmailToCust",
                "userName": sessionStorage.getItem('userName'),
                "password": sessionStorage.getItem('password'),
                "CafSafNo": cafSafNo,
                "ResendEmail": "Yes"
            }
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    // "token": "e7e916c2e449f6306b27dea2fb2dde46",
                },
                body: JSON.stringify(requestData),
            });
            const data = await response.json();
            // console.log("response", data);


        } catch (error) {
            console.error("Error fetching data:", error.message);
        }
    }


    return (
        <>
            {/* ***********Header********* */}
            <div className="container-fluid text-light Header-style header">
                <div className="p-3">
                    <span
                        className=""
                        style={{ cursor: "pointer" }}
                        onClick={redirectBroadbandCafformPage}
                    >
                        <i className="fa-solid fa-arrow-left-long"></i>
                    </span>
                    <span className="p-1 m-3">Broadband CAF</span>
                </div>
            </div>
            {/* ***********Header END********* */}

            <div>
                {loading ? (
                    <div className="loader-wrapper">
                        <div className="loader">
                            <img src={load} alt="loading...."></img>
                        </div>
                    </div>
                ) : (
                    <div
                        className=" container shadow mb-3 bg-body rounded form-container"
                        id="form8">
                        <form className="contact-form p-2">
                            <div className="input-box form-floating p-1">
                                <input
                                    type="text"
                                    placeholder=""
                                    className=" form-control input-text form-control-sm "
                                    id="fullName"
                                    name="fullName"
                                    // value={cafDocData.cafNo}
                                    value={cafSafNo}
                                />
                                <i
                                    className="fa-solid fa-lock text-secondary"
                                    style={{
                                        position: "absolute",
                                        right: "20px",
                                        top: "60%",
                                        transform: "translateY(-50%)",
                                    }}
                                ></i>
                                <label htmlFor="floatingInput" className="lock m-1">
                                    CAF No.*
                                </label>
                            </div>
                            {/* {console.log("cafDocData.cafNo", cafDocData.cafNo)} */}




                            <div className="">
                                <label className="select-search-label mt-1">Is GST applicable?</label>
                                <Select
                                    className=" basic-single form-control form-control-sm p-1"
                                    classNamePrefix="select"
                                    id="floatingSelect"
                                    aria-label="Floating label select example"
                                    name="dnc"
                                    styles={style}
                                    placeholder="Select Option"
                                    value={selectGst}
                                    onChange={handleIsGst}
                                    options={GstOpts.map((data) => ({
                                        value: data.value,
                                        label: data.label,
                                    }))}
                                />
                            </div>


                            {selectGst.label == "No" &&
                                <div className="">
                                    <label className="select-search-label mt-1">Declaration</label>
                                    <Select
                                        className=" basic-single form-control form-control-sm p-1"
                                        classNamePrefix="select"
                                        id="floatingSelect"
                                        aria-label="Floating label select example"
                                        name="dnc"
                                        styles={style}
                                        placeholder="Select Option"
                                        value={selectDec}
                                        onChange={handleGstDeclaration}
                                        options={DecOpts.map((data) => ({
                                            value: data.value,
                                            label: data.label,
                                        }))}
                                    />
                                </div>
                            }


                            {/* Form C */}
                            {firmType == "7" &&
                                <div className="border doc-styling">
                                    <div className="input-box form-floating"> 
                                        <input
                                            type="text"
                                            placeholder="Enter Form C number"
                                            className="form-control input-text form-control-sm"
                                            name="formNum"
                                            value={cafDocData?.formNum}
                                            disabled={formDocVerify === "Verified"}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="formNumber">Form C</label>

                                        {formDocVerify !== "Verified" && (
                                            <>
                                                {firmType !== "7" &&
                                                    <div className="form-check form-check-style">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            value="formCheck"
                                                            name="formCheck"
                                                            id="formCheck"
                                                            checked={isCheckboxChecked.formCheck}
                                                            onChange={handleCheckboxChange}
                                                        />
                                                        <label className="form-check-label" htmlFor="formCheck">
                                                            If the document is not available. Please click on the checkbox.
                                                        </label>
                                                    </div>}

                                                {(isCheckboxChecked.formCheck || selectedFormDate) ? (
                                                    <>
                                                        <div className='date-div'>
                                                            <label htmlFor="partnerDeedDate" className="date-label-div">
                                                                Expected Document Date
                                                            </label>
                                                        </div>
                                                        <div className="input-box form-floating d-flex align-items-center position-relative"
                                                            style={{
                                                                borderBottom: "1px solid #dee0de",
                                                                width: "100%",
                                                                // maxWidth: "1500px", // Adjust as needed
                                                            }}>
                                                            <DatePicker
                                                                selected={selectedFormDate}
                                                                onChange={(date) => {
                                                                    setSelectedFormDate(date);
                                                                    const adjustedDate = new Date(
                                                                        date.getFullYear(),
                                                                        date.getMonth(),
                                                                        date.getDate() + 1 // Add one day to correct the shift
                                                                    );
                                                                    handleDateChange(
                                                                        { target: { value: adjustedDate.toISOString().split("T")[0] } },
                                                                        "FormC"
                                                                    );
                                                                }}
                                                                filterDate={isWeekday}
                                                                dateFormat="dd-MM-yyyy"
                                                                placeholderText="Select Date"
                                                                className="form-control input-text form-control-sm p-2"
                                                                style={{
                                                                    width: "100%",
                                                                    paddingRight: "40px", // Ensure space for icon
                                                                    maxWidth: "1500px",
                                                                }}
                                                            />
                                                            <i
                                                                className="fa-solid fa-calendar-days position-absolute"
                                                                style={{
                                                                    right: "20px",
                                                                    top: "50%",
                                                                    transform: "translateY(-50%)",
                                                                    color: "#8b8c8b",
                                                                }}
                                                            ></i>
                                                        </div>
                                                    </>
                                                ) : null}
                                                {(selectedFormDate || formDocVerify !== "Verified") && (
                                                    <div
                                                        className="input-box form-floating mt-3"
                                                        style={{ position: "relative" }}
                                                    >
                                                        <input
                                                            id="formUpload"
                                                            type="file"
                                                            accept="image/*,application/pdf"
                                                            onChange={(e) => handleFileUpload(e, "FormC")}
                                                            style={{ display: "none" }}
                                                        />
                                                        <input
                                                            type="text"
                                                            placeholder=""
                                                            className="form-control input-text form-control-sm mt-1"
                                                            id="formFileName"
                                                            value={uploadedFormFile}
                                                            readOnly
                                                            onClick={() => document.getElementById("formUpload").click()}
                                                        />
                                                        <i
                                                            className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                                                            onClick={() => document.getElementById("formUpload").click()}
                                                        ></i>
                                                        <label htmlFor="formFileName" className="paperclip mt-2">
                                                            Form C Document*
                                                        </label>
                                                    </div>
                                                )}


                                                {/* 
                                            {(!uploadedCoiFile && coiDocVerify !== "Verified" && autherName) &&
                                                <div className="req-color">&nbsp;Required Field*</div>} */}

                                                {(!uploadedFormFile && formDocVerify !== "Verified" && autherName && (firmType == "7") && coiDocVerify !== "Verified") &&
                                                    <div className="req-color">&nbsp;Required Field*</div>}
                                            </>
                                        )}
                                    </div>

                                    {/* {console.log("selectedCoiDate", selectedCoiDate)} */}

                                    {/* COI Document Verification Status */}
                                    <div className="input-box form-floating">
                                        <div className="p-3 d-flex flex-column flex-sm-row doc-rej">
                                            <span className="mb-2 mb-sm-0">{cafDocData?.formDoc}</span>&nbsp;
                                            <span className="mb-sm-0 doc-rej-color">
                                                {cafDocData?.formDocRej ? `(${cafDocData.formDocRej})` : ""}
                                            </span>
                                        </div>

                                        {formDocVerify && (
                                            <>
                                                {formDocVerify === "Verified" ? (
                                                    <i
                                                        className="fa-solid fa-check"
                                                        style={{
                                                            position: "absolute",
                                                            right: "20px",
                                                            top: "70%",
                                                            transform: "translateY(-50%)",
                                                            color: "#77c171",
                                                        }}
                                                    ></i>
                                                ) : (
                                                    <>
                                                        <span><i
                                                            className="fa-solid fa-xmark"
                                                            style={{
                                                                position: "absolute",
                                                                right: "40px",
                                                                top: "60%",
                                                                transform: "translateY(-50%)",
                                                                color: "#f20d24",
                                                            }}
                                                        ></i></span>
                                                        <span className='border' style={{ cursor: "pointer" }} onClick={(e) => handleDeleteDoc(e, "FormC")}><i
                                                            className="fa-solid fa-trash"
                                                            style={{
                                                                position: "absolute",
                                                                right: "10px",
                                                                top: "60%",
                                                                transform: "translateY(-50%)",
                                                                color: "black",

                                                            }}
                                                        ></i></span>
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            }

                            {firmType == "7" && <div class="select-search-label text-center mt-3 mb-3">OR</div>}

                            {/* COI Number */}
                            {moaDocVerify !== "Verified" && mcaDocVerify !== "Verified" && (
                                <div className="border doc-styling">
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Enter COI Number"
                                            className="form-control input-text form-control-sm"
                                            name="coiNum"
                                            value={cafDocData?.coiNum}
                                            disabled={coiDocVerify === "Verified"}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="coiNumber">COI</label>

                                        {coiDocVerify !== "Verified" && (
                                            <>
                                                {/* <div className="form-check form-check-style">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value="coiCheck"
                                                    name="coiCheck"
                                                    id="coiCheck"
                                                    checked={isCheckboxChecked.coiCheck}
                                                    onChange={handleCheckboxChange}
                                                />
                                                <label className="form-check-label" htmlFor="coiCheck">
                                                    If the document is not available. Please click on the checkbox.
                                                </label>
                                            </div> */}

                                                {(isCheckboxChecked.coiCheck || selectedCoiDate) ? (
                                                    <>
                                                        <div className='date-div'>
                                                            <label htmlFor="partnerDeedDate" className="date-label-div">
                                                                Expected Document Date
                                                            </label>
                                                        </div>
                                                        <div className="input-box form-floating d-flex align-items-center position-relative"
                                                            style={{
                                                                borderBottom: "1px solid #dee0de",
                                                                width: "100%",
                                                                // maxWidth: "1500px", // Adjust as needed
                                                            }}>
                                                            <DatePicker
                                                                selected={selectedCoiDate}
                                                                onChange={(date) => {
                                                                    setSelectedCoiDate(date);
                                                                    const adjustedDate = new Date(
                                                                        date.getFullYear(),
                                                                        date.getMonth(),
                                                                        date.getDate() + 1 // Add one day to correct the shift
                                                                    );
                                                                    handleDateChange(
                                                                        { target: { value: adjustedDate.toISOString().split("T")[0] } },
                                                                        "coi"
                                                                    );
                                                                }}
                                                                filterDate={isWeekday}
                                                                dateFormat="dd-MM-yyyy"
                                                                placeholderText="Select Date"
                                                                className="form-control input-text form-control-sm p-2"
                                                                style={{
                                                                    width: "100%",
                                                                    paddingRight: "40px", // Ensure space for icon
                                                                    maxWidth: "1500px",
                                                                }}
                                                            />
                                                            <i
                                                                className="fa-solid fa-calendar-days position-absolute"
                                                                style={{
                                                                    right: "20px",
                                                                    top: "50%",
                                                                    transform: "translateY(-50%)",
                                                                    color: "#8b8c8b",
                                                                }}
                                                            ></i>
                                                        </div>
                                                    </>
                                                ) : null}
                                                {(selectedCoiDate || coiDocVerify !== "Verified") && (
                                                    <div
                                                        className="input-box form-floating mt-3"
                                                        style={{ position: "relative" }}
                                                    >
                                                        <input
                                                            id="coiUpload"
                                                            type="file"
                                                            accept="image/*,application/pdf"
                                                            onChange={(e) => handleFileUpload(e, "coi")}
                                                            style={{ display: "none" }}
                                                        />
                                                        <input
                                                            type="text"
                                                            placeholder=""
                                                            className="form-control input-text form-control-sm mt-1"
                                                            id="coiFileName"
                                                            value={uploadedCoiFile}
                                                            readOnly
                                                            onClick={() => document.getElementById("coiUpload").click()}
                                                        />
                                                        <i
                                                            className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                                                            onClick={() => document.getElementById("coiUpload").click()}
                                                        ></i>
                                                        <label htmlFor="coiFileName" className="paperclip mt-2">
                                                            COI Document*
                                                        </label>
                                                    </div>
                                                )}


                                                {/* 
                                            {(!uploadedCoiFile && coiDocVerify !== "Verified" && autherName) &&
                                                <div className="req-color">&nbsp;Required Field*</div>} */}

                                                {(!uploadedCoiFile && coiDocVerify !== "Verified" && autherName && (firmType == "3" || firmType == "4" || firmType == "7") && formDocVerify !== "Verified") &&
                                                    <div className="req-color">&nbsp;Required Field*</div>}
                                            </>
                                        )}
                                    </div>

                                    {/* {console.log("selectedCoiDate", selectedCoiDate)} */}

                                    {/* COI Document Verification Status */}
                                    <div className="input-box form-floating">
                                        <div className="p-3 d-flex flex-column flex-sm-row doc-rej">
                                            <span className="mb-2 mb-sm-0">{cafDocData?.coiDoc}</span>&nbsp;
                                            <span className="mb-sm-0 doc-rej-color">
                                                {cafDocData?.coiDocRej ? `(${cafDocData.coiDocRej})` : ""}
                                            </span>
                                        </div>

                                        {coiDocVerify && (
                                            <>
                                                {coiDocVerify === "Verified" ? (
                                                    <i
                                                        className="fa-solid fa-check"
                                                        style={{
                                                            position: "absolute",
                                                            right: "20px",
                                                            top: "70%",
                                                            transform: "translateY(-50%)",
                                                            color: "#77c171",
                                                        }}
                                                    ></i>
                                                ) : (
                                                    <>
                                                        <span><i
                                                            className="fa-solid fa-xmark"
                                                            style={{
                                                                position: "absolute",
                                                                right: "40px",
                                                                top: "60%",
                                                                transform: "translateY(-50%)",
                                                                color: "#f20d24",
                                                            }}
                                                        ></i></span>
                                                        <span className='border' style={{ cursor: "pointer" }} onClick={(e) => handleDeleteDoc(e, "coi")}><i
                                                            className="fa-solid fa-trash"
                                                            style={{
                                                                position: "absolute",
                                                                right: "10px",
                                                                top: "60%",
                                                                transform: "translateY(-50%)",
                                                                color: "black",

                                                            }}
                                                        ></i></span>
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            )}


                            {coiDocVerify !== "Verified" && moaDocVerify !== "Verified" && mcaDocVerify !== "Verified" && (
                                <div class="select-search-label text-center mt-3 mb-3">OR</div>
                            )}

                            {/* MOA Document */}
                            {coiDocVerify !== "Verified" && mcaDocVerify !== "Verified" && (
                                <div className="border doc-styling mb-3">
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Enter Purchase Order Number"
                                            className="form-control input-text form-control-sm"
                                            name="moaNum"
                                            value={cafDocData?.moaNum}
                                            disabled={moaDocVerify === "Verified"}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="moaNum">MOA</label>

                                        {moaDocVerify !== "Verified" && (
                                            <>
                                                {/* Checkbox to indicate document unavailability */}
                                                {/* <div className="form-check form-check-style">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value="moaCheck"
                                                    name="moaCheck"
                                                    id="moaCheck"
                                                    checked={isCheckboxChecked.moaCheck}
                                                    onChange={handleCheckboxChange}
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="moaCheck"
                                                >
                                                    If the document is not available. Please click on the checkbox.
                                                </label>
                                            </div> */}

                                                {/* Conditional fields for file upload or date input */}
                                                {(isCheckboxChecked.moaCheck || selectedMoaDate) ? (
                                                    <>
                                                        <div className='date-div'>
                                                            <label htmlFor="moaDate" className="date-label-div">
                                                                Expected Document Date
                                                            </label>
                                                        </div>
                                                        <div className="input-box form-floating d-flex align-items-center position-relative"
                                                            style={{
                                                                borderBottom: "1px solid #dee0de",
                                                                width: "100%",
                                                                // maxWidth: "1500px", // Adjust as needed
                                                            }}>

                                                            <DatePicker
                                                                selected={selectedMoaDate}
                                                                onChange={(date) => {
                                                                    setSelectedMoaDate(date);
                                                                    handleDateChange(
                                                                        { target: { value: date.toISOString().split("T")[0] } },
                                                                        "moa"
                                                                    );
                                                                }}
                                                                filterDate={isWeekday}
                                                                dateFormat="dd-MM-yyyy"
                                                                placeholderText="Select Date"
                                                                className="form-control input-text form-control-sm p-2"
                                                                style={{
                                                                    width: "100%",
                                                                    paddingRight: "40px", // Ensure space for icon
                                                                    maxWidth: "1500px",
                                                                }}
                                                            />

                                                            <i
                                                                className="fa-solid fa-calendar-days position-absolute"
                                                                style={{
                                                                    right: "20px",
                                                                    top: "50%",
                                                                    transform: "translateY(-50%)",
                                                                    color: "#8b8c8b",
                                                                }}
                                                            ></i>
                                                        </div>
                                                    </>
                                                ) : null}
                                                {(selectedMoaDate || moaDocVerify !== "Verified") && (
                                                    <div
                                                        className="input-box form-floating mt-3"
                                                        style={{ position: "relative" }}
                                                    >
                                                        <input
                                                            id="moaUpload"
                                                            type="file"
                                                            accept="image/*,application/pdf"
                                                            onChange={(e) => handleFileUpload(e, "moa")}
                                                            style={{ display: "none" }}
                                                        />
                                                        <input
                                                            type="text"
                                                            placeholder=""
                                                            className="form-control input-text form-control-sm mt-1"
                                                            value={uploadedMoaFile || ""}
                                                            readOnly
                                                            onClick={() =>
                                                                document.getElementById("moaUpload").click()
                                                            }
                                                        />
                                                        <i
                                                            className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                                                            onClick={() =>
                                                                document.getElementById("moaUpload").click()
                                                            }
                                                        ></i>
                                                        <label htmlFor="moaUpload" className="paperclip mt-2">
                                                            MOA Document*
                                                        </label>
                                                    </div>
                                                )}

                                                {(!uploadedMoaFile && moaDocVerify !== "Verified" && autherName && (firmType == "3" || firmType == "4")) &&
                                                    <div className="req-color">&nbsp;Required Field*</div>}
                                            </>
                                        )}
                                    </div>

                                    {/* Moa Order Verification Status */}
                                    <div className="input-box form-floating">
                                        <div className="p-3 d-flex flex-column flex-sm-row doc-rej">
                                            <span className="mb-2 mb-sm-0">{cafDocData.moaDoc}</span>&nbsp;
                                            <span className="mb-sm-0 doc-rej-color">
                                                {cafDocData.moaDocRej
                                                    ? `(${cafDocData.moaDocRej})`
                                                    : ""}
                                            </span>
                                        </div>

                                        {moaDocVerify && (
                                            <>
                                                {moaDocVerify === "Verified" ? (
                                                    <i
                                                        className="fa-solid fa-check"
                                                        style={{
                                                            position: "absolute",
                                                            right: "20px",
                                                            top: "70%",
                                                            transform: "translateY(-50%)",
                                                            color: "#77c171",
                                                        }}
                                                    ></i>
                                                ) : (
                                                    <>
                                                        <span><i
                                                            className="fa-solid fa-xmark"
                                                            style={{
                                                                position: "absolute",
                                                                right: "40px",
                                                                top: "60%",
                                                                transform: "translateY(-50%)",
                                                                color: "#f20d24",
                                                            }}
                                                        ></i></span>
                                                        <span className='border' style={{ cursor: "pointer" }} onClick={(e) => handleDeleteDoc(e, "moa")}><i
                                                            className="fa-solid fa-trash"
                                                            style={{
                                                                position: "absolute",
                                                                right: "10px",
                                                                top: "60%",
                                                                transform: "translateY(-50%)",
                                                                color: "black",

                                                            }}
                                                        ></i></span>

                                                    </>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            )}

                            {coiDocVerify !== "Verified" && moaDocVerify !== "Verified" && mcaDocVerify !== "Verified" && (
                                <div class="select-search-label text-center mt-3 mb-3">OR</div>
                            )}

                            {/* MCA Document */}
                            {coiDocVerify !== "Verified" && moaDocVerify !== "Verified" && (
                                <div className="border doc-styling mb-3">
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Enter Purchase Order Number"
                                            className="form-control input-text form-control-sm"
                                            name="mcaNum"
                                            value={cafDocData?.mcaNum}
                                            disabled={mcaDocVerify === "Verified"}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="mcaNum">MCA</label>

                                        {mcaDocVerify !== "Verified" && (
                                            <>
                                                {/* Checkbox to indicate document unavailability */}
                                                {/* <div className="form-check form-check-style">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value="mcaCheck"
                                                    name="mcaCheck"
                                                    id="mcaCheck"
                                                    checked={isCheckboxChecked.mcaCheck}
                                                    onChange={handleCheckboxChange}
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="mcaCheck"
                                                >
                                                    If the document is not available. Please click on the checkbox.
                                                </label>
                                            </div> */}

                                                {/* Conditional fields for file upload or date input */}
                                                {(isCheckboxChecked.mcaCheck || selectedMcaDate) ? (
                                                    <>
                                                        <div className='date-div'>
                                                            <label htmlFor="mcaDate" className="date-label-div">
                                                                Expected Document Date
                                                            </label>
                                                        </div>
                                                        <div className="input-box form-floating d-flex align-items-center position-relative"
                                                            style={{
                                                                borderBottom: "1px solid #dee0de",
                                                                width: "100%",
                                                                // maxWidth: "1500px", // Adjust as needed
                                                            }}>

                                                            <DatePicker
                                                                selected={selectedMcaDate}
                                                                onChange={(date) => {
                                                                    setSelectedMcaDate(date);
                                                                    handleDateChange(
                                                                        { target: { value: date.toISOString().split("T")[0] } },
                                                                        "mca"
                                                                    );
                                                                }}
                                                                filterDate={isWeekday}
                                                                dateFormat="dd-MM-yyyy"
                                                                placeholderText="Select Date"
                                                                className="form-control input-text form-control-sm p-2"
                                                                style={{
                                                                    width: "100%",
                                                                    paddingRight: "40px", // Ensure space for icon
                                                                    maxWidth: "1500px",
                                                                }}
                                                            />

                                                            <i
                                                                className="fa-solid fa-calendar-days position-absolute"
                                                                style={{
                                                                    right: "20px",
                                                                    top: "50%",
                                                                    transform: "translateY(-50%)",
                                                                    color: "#8b8c8b",
                                                                }}
                                                            ></i>
                                                        </div>
                                                    </>
                                                ) : null}
                                                {(selectedMcaDate || mcaDocVerify !== "Verified") && (
                                                    <div
                                                        className="input-box form-floating mt-3"
                                                        style={{ position: "relative" }}
                                                    >
                                                        <input
                                                            id="mcaUpload"
                                                            type="file"
                                                            accept="image/*,application/pdf"
                                                            onChange={(e) => handleFileUpload(e, "mca")}
                                                            style={{ display: "none" }}
                                                        />
                                                        <input
                                                            type="text"
                                                            placeholder=""
                                                            className="form-control input-text form-control-sm mt-1"
                                                            value={uploadedMcaFile || ""}
                                                            readOnly
                                                            onClick={() =>
                                                                document.getElementById("mcaUpload").click()
                                                            }
                                                        />
                                                        <i
                                                            className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                                                            onClick={() =>
                                                                document.getElementById("mcaUpload").click()
                                                            }
                                                        ></i>
                                                        <label htmlFor="mcaUpload" className="paperclip mt-2">
                                                            MCA Document*
                                                        </label>
                                                    </div>
                                                )}

                                                {(!uploadedMcaFile && mcaDocVerify !== "Verified" && autherName && (firmType == "3" || firmType == "4")) &&
                                                    <div className="req-color">&nbsp;Required Field*</div>}
                                            </>
                                        )}
                                    </div>

                                    {/* MCA Order Verification Status */}
                                    <div className="input-box form-floating">
                                        <div className="p-3 d-flex flex-column flex-sm-row doc-rej">
                                            <span className="mb-2 mb-sm-0">{cafDocData.mcaDoc}</span>&nbsp;
                                            <span className="mb-sm-0 doc-rej-color">
                                                {cafDocData.mcaDocRej
                                                    ? `(${cafDocData.mcaDocRej})`
                                                    : ""}
                                            </span>
                                        </div>

                                        {mcaDocVerify && (
                                            <>
                                                {mcaDocVerify === "Verified" ? (
                                                    <i
                                                        className="fa-solid fa-check"
                                                        style={{
                                                            position: "absolute",
                                                            right: "20px",
                                                            top: "70%",
                                                            transform: "translateY(-50%)",
                                                            color: "#77c171",
                                                        }}
                                                    ></i>
                                                ) : (
                                                    <>
                                                        <span>
                                                            <i
                                                                className="fa-solid fa-xmark"
                                                                style={{
                                                                    position: "absolute",
                                                                    right: "40px",
                                                                    top: "60%",
                                                                    transform: "translateY(-50%)",
                                                                    color: "#f20d24",
                                                                }}
                                                            ></i></span>
                                                        <span className='border' style={{ cursor: "pointer" }} onClick={(e) => handleDeleteDoc(e, "mca")}><i
                                                            className="fa-solid fa-trash"
                                                            style={{
                                                                position: "absolute",
                                                                right: "10px",
                                                                top: "60%",
                                                                transform: "translateY(-50%)",
                                                                color: "black",

                                                            }}
                                                        ></i></span>
                                                    </>

                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            )}


                            {/* Trust Deed */}
                            {firmType == "5" &&
                                <div className="border mt-2 doc-styling">
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Enter Deed Number"
                                            className="form-control input-text form-control-sm"
                                            name="deedNum"
                                            value={cafDocData?.deedNum}
                                            disabled={deedDocVerify === "Verified"}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="deedNumber">Trust Deed</label>

                                        {deedDocVerify !== "Verified" && (
                                            <>
                                                {firmType !== "5" &&
                                                    <div className="form-check form-check-style">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            value="deedCheck"
                                                            name="deedCheck"
                                                            id="deedCheck"
                                                            checked={isCheckboxChecked.deedCheck}
                                                            onChange={handleCheckboxChange}
                                                        />
                                                        <label className="form-check-label" htmlFor="panCheck">
                                                            If the document is not available. Please click on the checkbox.
                                                        </label>
                                                    </div>}

                                                {(isCheckboxChecked.deedCheck || selectedDeedDate) ? (
                                                    <>
                                                        <div className='date-div'>
                                                            <label htmlFor="partnerDeedDate" className="date-label-div">
                                                                Expected Document Date
                                                            </label>
                                                        </div>
                                                        <div className="input-box form-floating d-flex align-items-center position-relative"
                                                            style={{
                                                                borderBottom: "1px solid #dee0de",
                                                                width: "100%",
                                                                // maxWidth: "1500px", // Adjust as needed
                                                            }}>
                                                            <DatePicker
                                                                selected={selectedDeedDate}
                                                                onChange={(date) => {
                                                                    setSelectedDeedDate(date);
                                                                    const adjustedDate = new Date(
                                                                        date.getFullYear(),
                                                                        date.getMonth(),
                                                                        date.getDate() + 1 // Add one day to correct the shift
                                                                    );
                                                                    handleDateChange(
                                                                        { target: { value: adjustedDate.toISOString().split("T")[0] } },
                                                                        "deedNumber"
                                                                    );
                                                                }}
                                                                filterDate={isWeekday}
                                                                dateFormat="dd-MM-yyyy"
                                                                placeholderText="Select Date"
                                                                className="form-control input-text form-control-sm p-2"
                                                                style={{
                                                                    width: "100%",
                                                                    paddingRight: "40px", // Ensure space for icon
                                                                    maxWidth: "1500px",
                                                                }}
                                                            />
                                                            <i
                                                                className="fa-solid fa-calendar-days position-absolute"
                                                                style={{
                                                                    right: "20px",
                                                                    top: "50%",
                                                                    transform: "translateY(-50%)",
                                                                    color: "#8b8c8b",
                                                                }}
                                                            ></i>
                                                        </div>
                                                    </>
                                                ) : null}

                                                {(selectedDeedDate || deedDocVerify !== "Verified") && (
                                                    <div
                                                        className="input-box form-floating mt-3"
                                                        style={{ position: "relative" }}
                                                    >
                                                        <input
                                                            id="deedUpload"
                                                            type="file"
                                                            accept="image/*,application/pdf"
                                                            onChange={(e) => handleFileUpload(e, "deedNumber")}
                                                            style={{ display: "none" }}
                                                        />
                                                        <input
                                                            type="text"
                                                            placeholder=""
                                                            className="form-control input-text form-control-sm mt-1"
                                                            id="deedFileName"
                                                            value={uploadedDeedFile}
                                                            readOnly
                                                            onClick={() => document.getElementById("deedUpload").click()}
                                                        />
                                                        <i
                                                            className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                                                            onClick={() => document.getElementById("deedUpload").click()}
                                                        ></i>
                                                        <label htmlFor="deedFileName" className="paperclip mt-2">
                                                            Trust Deed
                                                        </label>
                                                    </div>
                                                )}

                                                {(!uploadedDeedFile && deedDocVerify !== "Verified") &&
                                                    <div className="req-color">&nbsp;Required Field*</div>}
                                            </>
                                        )}
                                    </div>

                                    {/* PAN Document Verification Status */}
                                    <div className="input-box form-floating">
                                        <div className="p-3 d-flex flex-column flex-sm-row doc-rej">
                                            <span className="mb-2 mb-sm-0">{cafDocData?.deedDoc}</span>&nbsp;
                                            <span className="mb-sm-0 doc-rej-color">
                                                {cafDocData?.deedDocRej ? `(${cafDocData.deedDocRej})` : ""}
                                            </span>
                                        </div>

                                        {deedDocVerify && (
                                            <>
                                                {deedDocVerify === "Verified" ? (
                                                    <i
                                                        className="fa-solid fa-check"
                                                        style={{
                                                            position: "absolute",
                                                            right: "20px",
                                                            top: "70%",
                                                            transform: "translateY(-50%)",
                                                            color: "#77c171",
                                                        }}
                                                    ></i>
                                                ) : (
                                                    <>
                                                        <span><i
                                                            className="fa-solid fa-xmark"
                                                            style={{
                                                                position: "absolute",
                                                                right: "40px",
                                                                top: "60%",
                                                                transform: "translateY(-50%)",
                                                                color: "#f20d24",
                                                            }}
                                                        ></i></span>
                                                        <span className='border' style={{ cursor: "pointer" }} onClick={(e) => handleDeleteDoc(e, "deedNumber")}><i
                                                            className="fa-solid fa-trash"
                                                            style={{
                                                                position: "absolute",
                                                                right: "10px",
                                                                top: "60%",
                                                                transform: "translateY(-50%)",
                                                                color: "black",

                                                            }}
                                                        ></i></span>

                                                    </>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>}

                            {/* Partnership Deed */}
                            {(firmType == "2" || firmType == '3' || firmType == '4') &&
                                <div className="border doc-styling">
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Enter Purchase Order Number"
                                            className="form-control input-text form-control-sm"
                                            name="partnerDeedNum"
                                            value={cafDocData?.partnerDeedNum}
                                            disabled={partnerDeedDocVerify === "Verified"}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="partnerDeedNum">Partnership Deed</label>

                                        {partnerDeedDocVerify !== "Verified" && (
                                            <>
                                                {/* Checkbox to indicate document unavailability */}
                                                <div className="form-check form-check-style">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        value="partnerDeedCheck"
                                                        name="partnerDeedCheck"
                                                        id="partnerDeedCheck"
                                                        checked={isCheckboxChecked.partnerDeedCheck}
                                                        onChange={handleCheckboxChange}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="partnerDeedCheck"
                                                    >
                                                        If the document is not available. Please click on the checkbox.
                                                    </label>
                                                </div>

                                                {/* Conditional fields for file upload or date input */}
                                                {(isCheckboxChecked.partnerDeedCheck || selectedPartnerDeedDate) ? (
                                                    <>
                                                        <div className='date-div'>
                                                            <label htmlFor="partnerDeedDate" className="date-label-div">
                                                                Expected Document Date
                                                            </label>
                                                        </div>
                                                        <div className="input-box form-floating d-flex align-items-center position-relative"
                                                            style={{
                                                                borderBottom: "1px solid #dee0de",
                                                                width: "100%",
                                                                // maxWidth: "1500px", // Adjust as needed
                                                            }}>

                                                            <DatePicker
                                                                selected={selectedPartnerDeedDate}
                                                                onChange={(date) => {
                                                                    setSelectedPartnerDeedDate(date);
                                                                    const adjustedDate = new Date(
                                                                        date.getFullYear(),
                                                                        date.getMonth(),
                                                                        date.getDate() + 1 // Add one day to correct the shift
                                                                    );
                                                                    handleDateChange(
                                                                        { target: { value: adjustedDate.toISOString().split("T")[0] } },
                                                                        "pd"
                                                                    );
                                                                }}
                                                                filterDate={isWeekday}
                                                                dateFormat="dd-MM-yyyy"
                                                                placeholderText="Select Date"
                                                                className="form-control input-text form-control-sm p-2"
                                                                style={{
                                                                    width: "100%",
                                                                    paddingRight: "40px", // Ensure space for icon
                                                                    maxWidth: "1500px",
                                                                }}
                                                            />

                                                            <i
                                                                className="fa-solid fa-calendar-days position-absolute"
                                                                style={{
                                                                    right: "20px",
                                                                    top: "50%",
                                                                    transform: "translateY(-50%)",
                                                                    color: "#8b8c8b",
                                                                }}
                                                            ></i>
                                                        </div>
                                                    </>
                                                ) : null}
                                                {(selectedPartnerDeedDate || partnerDeedDocVerify !== "Verified") && (
                                                    <div
                                                        className="input-box form-floating mt-3"
                                                        style={{ position: "relative" }}
                                                    >
                                                        <input
                                                            id="partnerDeedUpload"
                                                            type="file"
                                                            accept="image/*,application/pdf"
                                                            onChange={(e) => handleFileUpload(e, "pd")}
                                                            style={{ display: "none" }}
                                                        />
                                                        <input
                                                            type="text"
                                                            placeholder=""
                                                            className="form-control input-text form-control-sm mt-1"
                                                            value={uploadedpartnerDeedFile || ""}
                                                            readOnly
                                                            onClick={() =>
                                                                document.getElementById("partnerDeedUpload").click()
                                                            }
                                                        />
                                                        <i
                                                            className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                                                            onClick={() =>
                                                                document.getElementById("partnerDeedUpload").click()
                                                            }
                                                        ></i>
                                                        <label htmlFor="partnerDeedUpload" className="paperclip mt-2">
                                                            Partnership Deed*
                                                        </label>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>

                                    {/* partnerDeed Order Verification Status */}
                                    <div className="input-box form-floating">
                                        <div className="p-3 d-flex flex-column flex-sm-row doc-rej">
                                            <span className="mb-2 mb-sm-0">{cafDocData.partnerDeedDoc}</span>&nbsp;
                                            <span className="mb-sm-0 doc-rej-color">
                                                {cafDocData.partnerDeedDocRej
                                                    ? `(${cafDocData.partnerDeedDocRej})`
                                                    : ""}
                                            </span>
                                        </div>

                                        {partnerDeedDocVerify && (
                                            <>
                                                {partnerDeedDocVerify === "Verified" ? (
                                                    <i
                                                        className="fa-solid fa-check"
                                                        style={{
                                                            position: "absolute",
                                                            right: "20px",
                                                            top: "70%",
                                                            transform: "translateY(-50%)",
                                                            color: "#77c171",
                                                        }}
                                                    ></i>
                                                ) : (
                                                    <>
                                                        <span><i
                                                            className="fa-solid fa-xmark"
                                                            style={{
                                                                position: "absolute",
                                                                right: "40px",
                                                                top: "60%",
                                                                transform: "translateY(-50%)",
                                                                color: "#f20d24",
                                                            }}
                                                        ></i></span>
                                                        <span className='border' style={{ cursor: "pointer" }} onClick={(e) => handleDeleteDoc(e, "pd")}><i
                                                            className="fa-solid fa-trash"
                                                            style={{
                                                                position: "absolute",
                                                                right: "10px",
                                                                top: "60%",
                                                                transform: "translateY(-50%)",
                                                                color: "black",

                                                            }}
                                                        ></i></span>

                                                    </>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>}

                            {/* PAN Number */}
                            <div className="border mt-2 doc-styling">
                                <div className="input-box form-floating">
                                    <input
                                        type="text"
                                        placeholder="Enter PAN Number"
                                        className="form-control input-text form-control-sm"
                                        name="panNum"
                                        value={cafDocData?.panNum}
                                        disabled={panDocVerify === "Verified"}
                                        onChange={handleChange}
                                    // onBlur={handleBlur}
                                    />
                                    <label htmlFor="panNumber">Company PAN</label>

                                    {panDocVerify !== "Verified" && (
                                        <>
                                            {/* <div className="form-check form-check-style">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value="panCheck"
                                                    name="panCheck"
                                                    id="panCheck"
                                                    checked={isCheckboxChecked.panCheck}
                                                    onChange={handleCheckboxChange}
                                                />
                                                <label className="form-check-label" htmlFor="panCheck">
                                                    If the document is not available. Please click on the checkbox.
                                                </label>
                                            </div> */}

                                            {(isCheckboxChecked.panCheck || selectedPanDate) ? (
                                                <>
                                                    <div className='date-div'>
                                                        <label htmlFor="partnerDeedDate" className="date-label-div">
                                                            Expected Document Date
                                                        </label>
                                                    </div>
                                                    <div className="input-box form-floating d-flex align-items-center position-relative"
                                                        style={{
                                                            borderBottom: "1px solid #dee0de",
                                                            width: "100%",
                                                            // maxWidth: "1500px", // Adjust as needed
                                                        }}>
                                                        <DatePicker
                                                            selected={selectedPanDate}
                                                            onChange={(date) => {
                                                                setSelectedPanDate(date);
                                                                const adjustedDate = new Date(
                                                                    date.getFullYear(),
                                                                    date.getMonth(),
                                                                    date.getDate() + 1 // Add one day to correct the shift
                                                                );
                                                                handleDateChange(
                                                                    { target: { value: adjustedDate.toISOString().split("T")[0] } },
                                                                    "panNumber"
                                                                );
                                                            }}
                                                            filterDate={isWeekday}
                                                            dateFormat="dd-MM-yyyy"
                                                            placeholderText="Select Date"
                                                            className="form-control input-text form-control-sm p-2"
                                                            style={{
                                                                width: "100%",
                                                                paddingRight: "40px", // Ensure space for icon
                                                                maxWidth: "1500px",
                                                            }}
                                                        />
                                                        <i
                                                            className="fa-solid fa-calendar-days position-absolute"
                                                            style={{
                                                                right: "20px",
                                                                top: "50%",
                                                                transform: "translateY(-50%)",
                                                                color: "#8b8c8b",
                                                            }}
                                                        ></i>
                                                    </div>
                                                </>
                                            ) : null}
                                            {(selectedPanDate || panDocVerify !== "Verified") && (
                                                <div
                                                    className="input-box form-floating mt-3"
                                                    style={{ position: "relative" }}
                                                >
                                                    <input
                                                        id="panUpload"
                                                        type="file"
                                                        accept="image/*,application/pdf"
                                                        onChange={(e) => handleFileUpload(e, "panNumber")}
                                                        style={{ display: "none" }}
                                                    />
                                                    <input
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control input-text form-control-sm mt-1"
                                                        id="panFileName"
                                                        value={uploadedPanFile || ""}
                                                        readOnly
                                                        onClick={() => document.getElementById("panUpload").click()}
                                                    />
                                                    <i
                                                        className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                                                        onClick={() => document.getElementById("panUpload").click()}
                                                    ></i>
                                                    <label htmlFor="panFileName" className="paperclip mt-2">
                                                        PAN Document*
                                                    </label>
                                                </div>
                                            )}
                                        </>
                                    )}

                                    {(!uploadedPanFile && panDocVerify !== "Verified") &&
                                        <div className="req-color">&nbsp;Required Field*</div>}
                                </div>

                                {/* PAN Document Verification Status */}
                                <div className="input-box form-floating">
                                    <div className="p-3 d-flex flex-column flex-sm-row doc-rej">
                                        <span className="mb-2 mb-sm-0">{cafDocData?.panDoc}</span>&nbsp;
                                        <span className="mb-sm-0 doc-rej-color">
                                            {cafDocData?.panDocRej ? `(${cafDocData.panDocRej})` : ""}
                                        </span>
                                    </div>

                                    {panDocVerify && (
                                        <>
                                            {panDocVerify === "Verified" ? (
                                                <i
                                                    className="fa-solid fa-check"
                                                    style={{
                                                        position: "absolute",
                                                        right: "20px",
                                                        top: "70%",
                                                        transform: "translateY(-50%)",
                                                        color: "#77c171",
                                                    }}
                                                ></i>
                                            ) : (
                                                <>
                                                    <span><i
                                                        className="fa-solid fa-xmark"
                                                        style={{
                                                            position: "absolute",
                                                            right: "40px",
                                                            top: "60%",
                                                            transform: "translateY(-50%)",
                                                            color: "#f20d24",
                                                        }}
                                                    ></i></span>
                                                    <span className='border' style={{ cursor: "pointer" }} onClick={(e) => handleDeleteDoc(e, "panNumber")}><i
                                                        className="fa-solid fa-trash"
                                                        style={{
                                                            position: "absolute",
                                                            right: "10px",
                                                            top: "60%",
                                                            transform: "translateY(-50%)",
                                                            color: "black",

                                                        }}
                                                    ></i></span>

                                                </>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>


                            {/* GST */}
                            {/* firmType == "1" || firmType == "2" || firmType == "3" || firmType == "4" || firmType == "5" */}
                            {selectGst.label == "Yes" && (firmType == "1" || firmType == "2" || firmType == "3" || firmType == "4" || firmType == "5" || firmType == "7") && (
                                <div className="border doc-styling mt-2">
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Enter GST Number"
                                            className="form-control input-text form-control-sm"
                                            name="gstNum"
                                            value={cafDocData?.gstNum}
                                            disabled={gstDocVerify === "Verified"}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="gstNumber">GST Number</label>
                                        {gstDocVerify !== "Verified" && (
                                            <>
                                                {firmType == "5" &&
                                                    <div className="form-check form-check-style">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            value="gstCheck"
                                                            name="gstCheck"
                                                            id="gstCheck"
                                                            checked={isCheckboxChecked.gstCheck}
                                                            onChange={handleCheckboxChange}
                                                        />
                                                        <label className="form-check-label" htmlFor="gstCheck">
                                                            If the document is not available. Please click on the checkbox.
                                                        </label>
                                                    </div>}

                                                {(isCheckboxChecked.gstCheck || selectedGstDate) ? (
                                                    <>
                                                        <div className='date-div'>
                                                            <label htmlFor="partnerDeedDate" className="date-label-div">
                                                                Expected Document Date
                                                            </label>
                                                        </div>
                                                        <div className="input-box form-floating d-flex align-items-center position-relative"
                                                            style={{
                                                                borderBottom: "1px solid #dee0de",
                                                                width: "100%",
                                                                // maxWidth: "1500px", // Adjust as needed
                                                            }}>
                                                            <DatePicker
                                                                selected={selectedGstDate}
                                                                onChange={(date) => {
                                                                    setSelectedGstDate(date);
                                                                    const adjustedDate = new Date(
                                                                        date.getFullYear(),
                                                                        date.getMonth(),
                                                                        date.getDate() + 1 // Add one day to correct the shift
                                                                    );
                                                                    handleDateChange(
                                                                        { target: { value: adjustedDate.toISOString().split("T")[0] } },
                                                                        "gstNumber"
                                                                    );
                                                                }}
                                                                filterDate={isWeekday}
                                                                dateFormat="dd-MM-yyyy"
                                                                placeholderText="Select Date"
                                                                className="form-control input-text form-control-sm p-2"
                                                                style={{
                                                                    width: "100%",
                                                                    paddingRight: "40px", // Ensure space for icon
                                                                    maxWidth: "1500px",
                                                                }}
                                                            />
                                                            <i
                                                                className="fa-solid fa-calendar-days position-absolute"
                                                                style={{
                                                                    right: "20px",
                                                                    top: "50%",
                                                                    transform: "translateY(-50%)",
                                                                    color: "#8b8c8b",
                                                                }}
                                                            ></i>
                                                        </div>
                                                    </>
                                                ) : null}
                                                {(selectedGstDate || gstDocVerify !== "Verified") && (
                                                    <div
                                                        className="input-box form-floating mt-3"
                                                        style={{ position: "relative" }}
                                                    >
                                                        <input
                                                            id="gstUpload"
                                                            type="file"
                                                            accept="image/*,application/pdf"
                                                            onChange={(e) => handleFileUpload(e, "gstNumber")}
                                                            style={{ display: "none" }}
                                                        />
                                                        <input
                                                            type="text"
                                                            placeholder=""
                                                            className="form-control input-text form-control-sm mt-1"
                                                            id="gstFileName"
                                                            value={uploadedGstFile}
                                                            readOnly
                                                            onClick={() =>
                                                                document.getElementById("gstUpload").click()
                                                            }
                                                        />
                                                        {/* {console.log('uploadedGstFile',uploadedGstFile)} */}
                                                        <i
                                                            className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                                                            onClick={() =>
                                                                document.getElementById("gstUpload").click()
                                                            }
                                                        ></i>
                                                        <label htmlFor="gstFileName" className="paperclip mt-2">
                                                            GST Document*
                                                        </label>
                                                    </div>
                                                )}
                                            </>
                                        )}

                                        {(!uploadedGstFile && gstDocVerify !== "Verified" && firmType !== "5") &&
                                            <div className='req-color'>&nbsp;Required Field*</div>}

                                    </div>

                                    {/* GST Document Verification Status */}
                                    <div className="input-box form-floating">
                                        <div className="p-3 d-flex flex-column flex-sm-row doc-rej">
                                            <span className="mb-2 mb-sm-0">{cafDocData?.gstDoc}</span>
                                            &nbsp;
                                            <span className="mb-sm-0 doc-rej-color">
                                                {cafDocData?.gstDocRej ? `(${cafDocData.gstDocRej})` : ""}
                                            </span>
                                        </div>

                                        {gstDocVerify && (
                                            <>
                                                {gstDocVerify === "Verified" ? (
                                                    <i
                                                        className="fa-solid fa-check"
                                                        style={{
                                                            position: "absolute",
                                                            right: "20px",
                                                            top: "70%",
                                                            transform: "translateY(-50%)",
                                                            color: "#77c171",
                                                        }}
                                                    ></i>
                                                ) : (
                                                    <>
                                                        <span><i
                                                            className="fa-solid fa-xmark"
                                                            style={{
                                                                position: "absolute",
                                                                right: "40px",
                                                                top: "60%",
                                                                transform: "translateY(-50%)",
                                                                color: "#f20d24",
                                                            }}
                                                        ></i></span>
                                                        <span className='border' style={{ cursor: "pointer" }} onClick={(e) => handleDeleteDoc(e, "gstNumber")}><i
                                                            className="fa-solid fa-trash"
                                                            style={{
                                                                position: "absolute",
                                                                right: "10px",
                                                                top: "60%",
                                                                transform: "translateY(-50%)",
                                                                color: "black",

                                                            }}
                                                        ></i></span>

                                                    </>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            )}


                            {/* TAN */}
                            {(firmType == "1" || firmType == "2" || firmType == "3" || firmType == "4") &&
                                <div className="border doc-styling">
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Enter TAN Number"
                                            className="form-control input-text form-control-sm"
                                            name="tanNum"
                                            value={cafDocData?.tanNum}
                                            disabled={tanDocVerify === "Verified"}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="tanNumber">TAN Number</label>
                                        {tanDocVerify !== "Verified" && (
                                            <>
                                                <div className="form-check form-check-style">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        value="tanCheck"
                                                        name="tanCheck"
                                                        id="tanCheck"
                                                        checked={isCheckboxChecked.tanCheck}
                                                        onChange={handleCheckboxChange}
                                                    />
                                                    <label className="form-check-label" htmlFor="tanCheck">
                                                        If the document is not available. Please click on the checkbox.
                                                    </label>
                                                </div>

                                                {(isCheckboxChecked.tanCheck || selectedTanDate) ? (
                                                    <>
                                                        <div className='date-div'>
                                                            <label htmlFor="partnerDeedDate" className="date-label-div">
                                                                Expected Document Date
                                                            </label>
                                                        </div>
                                                        <div className="input-box form-floating d-flex align-items-center position-relative"
                                                            style={{
                                                                borderBottom: "1px solid #dee0de",
                                                                width: "100%",
                                                                // maxWidth: "1500px", // Adjust as needed
                                                            }}>
                                                            <DatePicker
                                                                selected={selectedTanDate}
                                                                onChange={(date) => {
                                                                    setSelectedTanDate(date);
                                                                    const adjustedDate = new Date(
                                                                        date.getFullYear(),
                                                                        date.getMonth(),
                                                                        date.getDate() + 1 // Add one day to correct the shift
                                                                    );
                                                                    handleDateChange(
                                                                        { target: { value: adjustedDate.toISOString().split("T")[0] } },
                                                                        "tanNumber"
                                                                    );
                                                                }}
                                                                filterDate={isWeekday}
                                                                dateFormat="dd-MM-yyyy"
                                                                placeholderText="Select Date"
                                                                className="form-control input-text form-control-sm p-2"
                                                                style={{
                                                                    width: "100%",
                                                                    paddingRight: "40px", // Ensure space for icon
                                                                    maxWidth: "1500px",
                                                                }}
                                                            />
                                                            <i
                                                                className="fa-solid fa-calendar-days position-absolute"
                                                                style={{
                                                                    right: "20px",
                                                                    top: "50%",
                                                                    transform: "translateY(-50%)",
                                                                    color: "#8b8c8b",
                                                                }}
                                                            ></i>
                                                        </div>
                                                    </>
                                                ) : null}
                                                {(selectedTanDate || tanDocVerify !== "Verified") && (
                                                    <div
                                                        className="input-box form-floating mt-3"
                                                        style={{ position: "relative" }}
                                                    >
                                                        <input
                                                            id="tanUpload"
                                                            type="file"
                                                            accept="image/*,application/pdf"
                                                            onChange={(e) => handleFileUpload(e, "tanNumber")}
                                                            style={{ display: "none" }}
                                                        />
                                                        <input
                                                            type="text"
                                                            placeholder=""
                                                            className="form-control input-text form-control-sm mt-1"
                                                            id="tanFileName"
                                                            value={uploadedTanFile || ""}
                                                            readOnly
                                                            onClick={() =>
                                                                document.getElementById("tanUpload").click()
                                                            }
                                                        />
                                                        <i
                                                            className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                                                            onClick={() =>
                                                                document.getElementById("tanUpload").click()
                                                            }
                                                        ></i>
                                                        <label htmlFor="tanFileName" className="paperclip mt-2">
                                                            TAN Document*
                                                        </label>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>

                                    {/* Verification Status */}
                                    <div className="input-box form-floating">
                                        <div className="p-3 d-flex flex-column flex-sm-row doc-rej">
                                            <span className="mb-2 mb-sm-0">{cafDocData.tanDoc}</span>
                                            &nbsp;
                                            <span className="mb-sm-0 doc-rej-color">
                                                {cafDocData.tanDocRej ? `(${cafDocData.tanDocRej})` : ""}
                                            </span>
                                        </div>

                                        {tanDocVerify && (
                                            <>
                                                {tanDocVerify === "Verified" ? (
                                                    <i
                                                        className="fa-solid fa-check"
                                                        style={{
                                                            position: "absolute",
                                                            right: "20px",
                                                            top: "70%",
                                                            transform: "translateY(-50%)",
                                                            color: "#77c171",
                                                        }}
                                                    ></i>
                                                ) : (
                                                    <>
                                                        <span><i
                                                            className="fa-solid fa-xmark"
                                                            style={{
                                                                position: "absolute",
                                                                right: "40px",
                                                                top: "60%",
                                                                transform: "translateY(-50%)",
                                                                color: "#f20d24",
                                                            }}
                                                        ></i></span>
                                                        <span className='border' style={{ cursor: "pointer" }} onClick={(e) => handleDeleteDoc(e, "tanNumber")}><i
                                                            className="fa-solid fa-trash"
                                                            style={{
                                                                position: "absolute",
                                                                right: "10px",
                                                                top: "60%",
                                                                transform: "translateY(-50%)",
                                                                color: "black",

                                                            }}
                                                        ></i></span>

                                                    </>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            }

                            {/* Registration Certificate*/}
                            {(firmType == "1" || firmType == "2") &&
                                <div className="border doc-styling">
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Enter Registration Number"
                                            className="form-control input-text form-control-sm"
                                            name="tanNum"
                                            disabled={registationDocVerify === "Verified"}
                                            value={cafDocData.registationNum}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="tanNum">Registration Certificate</label>
                                        {registationDocVerify !== "Verified" && (
                                            <>
                                                {(firmType !== "1" || firmType !== "2") &&
                                                    <div className="form-check form-check-style">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            value="registationCheck"
                                                            name="registationCheck"
                                                            id="registationCheck"
                                                            checked={isCheckboxChecked.registationCheck}
                                                            onChange={handleCheckboxChange}
                                                        />
                                                        <label className="form-check-label" htmlFor="registationCheck">
                                                            If the document is not available. Please click on the checkbox.
                                                        </label>
                                                    </div>}

                                                {(isCheckboxChecked.registationCheck || selectedRegDate) ? (
                                                    <>
                                                        <div className='date-div'>
                                                            <label htmlFor="partnerDeedDate" className="date-label-div">
                                                                Expected Document Date
                                                            </label>
                                                        </div>
                                                        <div className="input-box form-floating d-flex align-items-center position-relative"
                                                            style={{
                                                                borderBottom: "1px solid #dee0de",
                                                                width: "100%",
                                                                // maxWidth: "1500px", // Adjust as needed
                                                            }}>
                                                            <DatePicker
                                                                selected={selectedRegDate}
                                                                onChange={(date) => {
                                                                    setSelectedRegDate(date);
                                                                    const adjustedDate = new Date(
                                                                        date.getFullYear(),
                                                                        date.getMonth(),
                                                                        date.getDate() + 1 // Add one day to correct the shift
                                                                    );
                                                                    handleDateChange(
                                                                        { target: { value: adjustedDate.toISOString().split("T")[0] } },
                                                                        "registationNumber"
                                                                    );
                                                                }}
                                                                filterDate={isWeekday}
                                                                dateFormat="dd-MM-yyyy"
                                                                placeholderText="Select Date"
                                                                className="form-control input-text form-control-sm p-2"
                                                                style={{
                                                                    width: "100%",
                                                                    paddingRight: "40px", // Ensure space for icon
                                                                    maxWidth: "1500px",
                                                                }}
                                                            />
                                                            <i
                                                                className="fa-solid fa-calendar-days position-absolute"
                                                                style={{
                                                                    right: "20px",
                                                                    top: "50%",
                                                                    transform: "translateY(-50%)",
                                                                    color: "#8b8c8b",
                                                                }}
                                                            ></i>
                                                        </div>
                                                    </>
                                                ) : null}
                                                {(selectedRegDate || registationDocVerify !== "Verified") && (
                                                    <div
                                                        className="input-box form-floating mt-3"
                                                        style={{ position: "relative" }}
                                                    >
                                                        <input
                                                            id="registationUpload"
                                                            type="file"
                                                            accept="image/*,application/pdf"
                                                            onChange={(e) => handleFileUpload(e, "registationNumber")}
                                                            style={{ display: "none" }}
                                                        />
                                                        <input
                                                            type="text"
                                                            placeholder=""
                                                            className="form-control input-text form-control-sm mt-1"
                                                            id="registationText"
                                                            value={uploadedRegFile}
                                                            readOnly
                                                            onClick={() =>
                                                                document.getElementById("registationUpload").click()
                                                            }
                                                        />
                                                        <i
                                                            className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                                                            onClick={() =>
                                                                document.getElementById("registationUpload").click()
                                                            }
                                                        ></i>
                                                        <label htmlFor="registationText" className="paperclip mt-2">
                                                            Registration Certificate*
                                                        </label>
                                                    </div>
                                                )}
                                            </>
                                        )}

                                        {(!uploadedRegFile && registationDocVerify !== "Verified" && firmType == "2") &&
                                            <div className="req-color">&nbsp;Required Field*</div>}
                                    </div>


                                    <div className="input-box form-floating">
                                        <div className="p-3 d-flex flex-column flex-sm-row doc-rej">
                                            <span className="mb-2 mb-sm-0">{cafDocData.registationDoc}</span>
                                            &nbsp;
                                            <span className="mb-sm-0 doc-rej-color">
                                                {cafDocData.registationDocRej
                                                    ? `(${cafDocData.registationDocRej})`
                                                    : ""}
                                            </span>
                                        </div>

                                        {registationDocVerify && (
                                            <>
                                                {registationDocVerify === "Verified" ? (
                                                    <i
                                                        className="fa-solid fa-check"
                                                        style={{
                                                            position: "absolute",
                                                            right: "20px",
                                                            top: "70%",
                                                            transform: "translateY(-50%)",
                                                            color: "#77c171",
                                                        }}
                                                    ></i>
                                                ) : (
                                                    <>
                                                        <span><i
                                                            className="fa-solid fa-xmark"
                                                            style={{
                                                                position: "absolute",
                                                                right: "40px",
                                                                top: "60%",
                                                                transform: "translateY(-50%)",
                                                                color: "#f20d24",
                                                            }}
                                                        ></i></span>
                                                        <span className='border' style={{ cursor: "pointer" }} onClick={(e) => handleDeleteDoc(e, "registationNumber")}><i
                                                            className="fa-solid fa-trash"
                                                            style={{
                                                                position: "absolute",
                                                                right: "10px",
                                                                top: "60%",
                                                                transform: "translateY(-50%)",
                                                                color: "black",

                                                            }}
                                                        ></i></span>

                                                    </>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            }

                            {/* Auth Latter*/}
                            <div className="border mt-2 doc-styling">
                                <div className="input-box form-floating">
                                    <input
                                        type="text"
                                        placeholder="Enter Authorisation Letter"
                                        className="form-control input-text form-control-sm"
                                        name="authLetterNum"
                                        value={cafDocData.authLetterNum}
                                        disabled={authLetterDocVerify === "Verified"}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="authLetterNum">Authorisation Letter</label>

                                    {authLetterDocVerify !== "Verified" && (
                                        <>
                                            {/* Checkbox for unavailable document */}
                                            {!autherName && (firmType !== "3" || firmType !== "4") &&
                                                <div className="form-check form-check-style">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        value="authLetterCheck"
                                                        name="authLetterCheck"
                                                        id="authLetterCheck"
                                                        checked={isCheckboxChecked.authLetterCheck}
                                                        onChange={handleCheckboxChange}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="authLetterCheck"
                                                    >
                                                        If the document is not available. Please click on the checkbox.
                                                    </label>
                                                </div>}

                                            {/* Conditional input fields for date or file upload */}
                                            {(isCheckboxChecked.authLetterCheck || selectedAuthDate) ? (
                                                <>
                                                    <div className='date-div'>
                                                        <label htmlFor="partnerDeedDate" className="date-label-div">
                                                            Expected Document Date
                                                        </label>
                                                    </div>
                                                    <div
                                                        className="input-box form-floating d-flex align-items-center position-relative"
                                                        style={{
                                                            borderBottom: "1px solid #dee0de",
                                                            width: "100%",
                                                            // maxWidth: "1500px", // Adjust as needed
                                                        }}>
                                                        <DatePicker
                                                            selected={selectedAuthDate}
                                                            onChange={(date) => {
                                                                setSelectedAuthDate(date);
                                                                const adjustedDate = new Date(
                                                                    date.getFullYear(),
                                                                    date.getMonth(),
                                                                    date.getDate() + 1 // Add one day to correct the shift
                                                                );
                                                                handleDateChange(
                                                                    { target: { value: adjustedDate.toISOString().split("T")[0] } },
                                                                    "authorisationLetter"
                                                                );
                                                            }}
                                                            filterDate={isWeekday}
                                                            dateFormat="dd-MM-yyyy"
                                                            placeholderText="Select Date"
                                                            className="form-control input-text form-control-sm p-2"
                                                            style={{
                                                                width: "100%",
                                                                paddingRight: "40px", // Ensure space for icon
                                                                maxWidth: "1500px",
                                                            }}
                                                        />
                                                        <i
                                                            className="fa-solid fa-calendar-days position-absolute"
                                                            style={{
                                                                right: "20px",
                                                                top: "50%",
                                                                transform: "translateY(-50%)",
                                                                color: "#8b8c8b",
                                                            }}
                                                        ></i>
                                                    </div>
                                                </>
                                            ) : null}
                                            {(selectedAuthDate || authLetterDocVerify !== "Verified") && (
                                                <div
                                                    className="input-box form-floating mt-3"
                                                    style={{ position: "relative" }}
                                                >
                                                    <input
                                                        id="authLetterUpload"
                                                        type="file"
                                                        accept="image/*,application/pdf"
                                                        onChange={(e) =>
                                                            handleFileUpload(e, "authorisationLetter")
                                                        }
                                                        style={{ display: "none" }}
                                                    />
                                                    <input
                                                        type="text"
                                                        className="form-control input-text form-control-sm"
                                                        value={uploadedAuthFile}
                                                        readOnly
                                                        onClick={() =>
                                                            document.getElementById("authLetterUpload").click()
                                                        }
                                                    />
                                                    <i
                                                        className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                                                        onClick={() =>
                                                            document.getElementById("authLetterUpload").click()
                                                        }
                                                    ></i>
                                                    <label
                                                        htmlFor="authLetterUpload"
                                                        className="paperclip mt-2"
                                                    >
                                                        Upload Authorisation Letter*
                                                    </label>
                                                </div>
                                            )}
                                        </>
                                    )}
                                    {(!uploadedAuthFile && authLetterDocVerify !== "Verified" && autherName && (firmType == "3" || firmType == "4")) &&
                                        <div className="req-color">&nbsp;Required Field*</div>}
                                </div>

                                {/* {console.log("firmType",firmType)} */}

                                {/* Authorisation Letter Document Verification Status */}
                                <div className="input-box form-floating">
                                    <div className="p-3 d-flex flex-column flex-sm-row doc-rej">
                                        <span className="mb-2 mb-sm-0">{cafDocData.authLetterDoc}</span>&nbsp;
                                        <span className="mb-sm-0 doc-rej-color">
                                            {cafDocData.authDocRej
                                                ? `(${cafDocData.authDocRej})`
                                                : ""}
                                        </span>
                                    </div>

                                    {authLetterDocVerify && (
                                        <>
                                            {authLetterDocVerify === "Verified" ? (
                                                <i
                                                    className="fa-solid fa-check"
                                                    style={{
                                                        position: "absolute",
                                                        right: "20px",
                                                        top: "70%",
                                                        transform: "translateY(-50%)",
                                                        color: "#77c171",
                                                    }}
                                                ></i>
                                            ) : (
                                                <>
                                                    <span><i
                                                        className="fa-solid fa-xmark"
                                                        style={{
                                                            position: "absolute",
                                                            right: "40px",
                                                            top: "60%",
                                                            transform: "translateY(-50%)",
                                                            color: "#f20d24",
                                                        }}
                                                    ></i></span>
                                                    <span className='border' style={{ cursor: "pointer" }} onClick={(e) => handleDeleteDoc(e, "authorisationLetter")}><i
                                                        className="fa-solid fa-trash"
                                                        style={{
                                                            position: "absolute",
                                                            right: "10px",
                                                            top: "60%",
                                                            transform: "translateY(-50%)",
                                                            color: "black",

                                                        }}
                                                    ></i></span>

                                                </>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>


                            {/* POI */}
                            {/* <div className="border mt-2 doc-styling">
                                <div className="input-box form-floating">
                                    <input
                                        type="text"
                                        placeholder="Enter Photo Proof Number"
                                        className="form-control input-text form-control-sm"
                                        name="poiNum"
                                        value={cafDocData.poiNum}
                                        disabled={poiDocVerify === "Verified"}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="poiNum">POI</label>
                                </div>

                                <div>
                                    <label className="select-search-label mt-1">POI</label>
                                    <Select
                                        className="basic-single form-control form-control-sm p-1"
                                        classNamePrefix="select"
                                        name="poi"
                                        placeholder="Select Option"
                                        styles={style}
                                        value={selectPoi}
                                        isSearchable={false}
                                        onChange={handleSelectPoi}
                                        options={optionPoi.map((data) => ({
                                            value: data.value,
                                            label: data.label,
                                        }))}
                                    />

                                    {photoDocVerify !== "Verified" && (
                                        <>
                                          
                                            <div className="form-check form-check-style mt-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value="poiCheck"
                                                    name="poiCheck"
                                                    id="poiCheck"
                                                    checked={isCheckboxChecked.poiCheck}
                                                    onChange={handleCheckboxChange}
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="poiCheck"
                                                >
                                                    If the document is not available. Please click on the checkbox.
                                                </label>
                                            </div>

                                           
                                            {isCheckboxChecked.poiCheck ? (
                                                <div className="input-box form-floating mt-2">
                                                    <input
                                                        type="date"
                                                        className="form-control input-text form-control-sm"
                                                        id="poiDate"
                                                        name="poiDate"
                                                        value={cafDocData.poidate}
                                                        onChange={(e) => handleDateChange(e, "poi")}
                                                        max={maxDate}
                                                        min={minDate}
                                                    />
                                                    <label htmlFor="poiDate" className="p-2">
                                                       Expected Document Date
                                                    </label>
                                                </div>
                                            ) : (
                                                <div
                                                    className="input-box form-floating mt-2"
                                                    style={{ position: "relative" }}
                                                >
                                                    <input
                                                        id="poiUpload"
                                                        type="file"
                                                        accept=".pdf,.jpg,.jpeg,.png"
                                                        onChange={(e) => handleFileUpload(e, "poi")}
                                                        style={{ display: "none" }}
                                                    />
                                                    <input
                                                        type="text"
                                                        className="form-control input-text form-control-sm"
                                                        value={uploadedPoiFile}
                                                        readOnly
                                                        onClick={() =>
                                                            document
                                                                .getElementById("poiUpload")
                                                                .click()
                                                        }
                                                    />
                                                    <i
                                                        className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                                                        onClick={() =>
                                                            document
                                                                .getElementById("poiUpload")
                                                                .click()
                                                        }
                                                    ></i>
                                                    <label
                                                        htmlFor="poiUpload"
                                                        className="paperclip mt-2"
                                                    >
                                                        POI*
                                                    </label>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>

                               
                                <div className="input-box form-floating mt-3">
                                    <div className="p-3 d-flex flex-column flex-sm-row doc-rej">
                                        <span className="mb-2 mb-sm-0">{cafDocData.poiDoc}</span>&nbsp;
                                        <span className="mb-sm-0 doc-rej-color">
                                            {cafDocData.poiDocRej
                                                ? `(${cafDocData.poiDocRej})`
                                                : ""}
                                        </span>
                                    </div>

                                    {poiDocVerify && (
                                        <>
                                            {poiDocVerify === "Verified" ? (
                                                <i
                                                    className="fa-solid fa-check"
                                                    style={{
                                                        position: "absolute",
                                                        right: "20px",
                                                        top: "70%",
                                                        transform: "translateY(-50%)",
                                                        color: "#77c171",
                                                    }}
                                                ></i>
                                            ) : (
                                                <i
                                                    className="fa-solid fa-xmark"
                                                    style={{
                                                        position: "absolute",
                                                        right: "20px",
                                                        top: "70%",
                                                        transform: "translateY(-50%)",
                                                        color: "#f20d24",
                                                    }}
                                                ></i>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div> */}


                            {/* Photo Proof */}
                            <div className="border mt-2 doc-styling">
                                <div className="input-box form-floating">
                                    <input
                                        type="text"
                                        placeholder="Enter Photo Proof Number"
                                        className="form-control input-text form-control-sm"
                                        name="photoProofNum"
                                        value={cafDocData.photoProofNum}
                                        disabled={photoDocVerify === "Verified"}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="photoProofNum">Photo Proof Number Of Authorised Person </label>
                                </div>

                                <div>
                                    <label className="select-search-label mt-1">Photo Proof Of Authorised Person</label>
                                    <Select
                                        className="basic-single form-control form-control-sm p-1"
                                        classNamePrefix="select"
                                        name="photoProof"
                                        placeholder="Select Option"
                                        styles={style}
                                        value={selectPhotoProof}
                                        isSearchable={false}
                                        onChange={handleSelectPhotoProof}
                                        options={optionPhotoProof.map((data) => ({
                                            value: data.value,
                                            label: data.label,
                                        }))}
                                    />

                                    {photoDocVerify !== "Verified" && (
                                        <>
                                            {firmType == "5" &&
                                                <div className="form-check form-check-style mt-2">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        value="photoProofCheck"
                                                        name="photoProofCheck"
                                                        id="photoProofCheck"
                                                        checked={isCheckboxChecked.photoProofCheck}
                                                        onChange={handleCheckboxChange}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="photoProofCheck"
                                                    >
                                                        If the document is not available. Please click on the checkbox.
                                                    </label>
                                                </div>}

                                            {(isCheckboxChecked.photoProofCheck || selectedPhotoProofDate) ? (
                                                <>
                                                    <div className='date-div'>
                                                        <label htmlFor="partnerDeedDate" className="date-label-div">
                                                            Expected Document Date
                                                        </label>
                                                    </div>
                                                    <div className="input-box form-floating d-flex align-items-center position-relative"
                                                        style={{
                                                            borderBottom: "1px solid #dee0de",
                                                            width: "100%",
                                                            // maxWidth: "1500px", // Adjust as needed
                                                        }}>
                                                        <DatePicker
                                                            selected={selectedPhotoProofDate}
                                                            onChange={(date) => {
                                                                setSelectedPhotoProofDate(date);
                                                                const adjustedDate = new Date(
                                                                    date.getFullYear(),
                                                                    date.getMonth(),
                                                                    date.getDate() + 1 // Add one day to correct the shift
                                                                );
                                                                handleDateChange(
                                                                    { target: { value: adjustedDate.toISOString().split("T")[0] } },
                                                                    "photoProof"
                                                                );
                                                            }}
                                                            filterDate={isWeekday}
                                                            dateFormat="dd-MM-yyyy"
                                                            placeholderText="Select Date"
                                                            className="form-control input-text form-control-sm p-2"
                                                            style={{
                                                                width: "100%",
                                                                paddingRight: "40px", // Ensure space for icon
                                                                maxWidth: "1500px",
                                                            }}
                                                        />
                                                        <i
                                                            className="fa-solid fa-calendar-days position-absolute"
                                                            style={{
                                                                right: "20px",
                                                                top: "50%",
                                                                transform: "translateY(-50%)",
                                                                color: "#8b8c8b",
                                                            }}
                                                        ></i>
                                                    </div>
                                                </>
                                            ) : null}
                                            {(selectedPhotoProofDate || photoDocVerify !== "Verified") && (
                                                <div
                                                    className="input-box form-floating mt-2"
                                                    style={{ position: "relative" }}
                                                >
                                                    <input
                                                        id="photoProofUpload"
                                                        disabled={!selectPhotoProof?.value}
                                                        type="file"
                                                        accept=".pdf,.jpg,.jpeg,.png"
                                                        onChange={(e) => handleFileUpload(e, "photoProof")}
                                                        style={{ display: "none" }}
                                                    />
                                                    <input
                                                        type="text"
                                                        className="form-control input-text form-control-sm"
                                                        value={uploadedPhotoFile}
                                                        readOnly
                                                        onClick={() =>
                                                            document
                                                                .getElementById("photoProofUpload")
                                                                .click()
                                                        }
                                                    />
                                                    <i
                                                        className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                                                        onClick={() =>
                                                            document
                                                                .getElementById("photoProofUpload")
                                                                .click()
                                                        }
                                                    ></i>
                                                    <label
                                                        htmlFor="photoProofUpload"
                                                        className="paperclip mt-2"
                                                    >
                                                        Upload Photo Proof Of Authorised Person*
                                                    </label>
                                                </div>
                                            )}
                                        </>
                                    )}

                                    {(!uploadedPhotoFile && photoDocVerify !== "Verified" && firmType !== "5" && autherName) &&
                                        <div className='req-color'>&nbsp;Required Field*</div>}
                                </div>

                                {/* Photo Proof Document Verification Status */}
                                <div className="input-box form-floating mt-3">
                                    <div className="p-3 d-flex flex-column flex-sm-row doc-rej">
                                        <span className="mb-2 mb-sm-0">{cafDocData.photoProofDoc}</span>&nbsp;
                                        <span className="mb-sm-0 doc-rej-color">
                                            {cafDocData.photoDocRej
                                                ? `(${cafDocData.photoDocRej})`
                                                : ""}
                                        </span>
                                    </div>

                                    {photoDocVerify && (
                                        <>
                                            {photoDocVerify === "Verified" ? (
                                                <i
                                                    className="fa-solid fa-check"
                                                    style={{
                                                        position: "absolute",
                                                        right: "20px",
                                                        top: "70%",
                                                        transform: "translateY(-50%)",
                                                        color: "#77c171",
                                                    }}
                                                ></i>
                                            ) : (
                                                <>
                                                    <span><i
                                                        className="fa-solid fa-xmark"
                                                        style={{
                                                            position: "absolute",
                                                            right: "40px",
                                                            top: "60%",
                                                            transform: "translateY(-50%)",
                                                            color: "#f20d24",
                                                        }}
                                                    ></i></span>
                                                    <span className='border' style={{ cursor: "pointer" }} onClick={(e) => handleDeleteDoc(e, "photoProof")}><i
                                                        className="fa-solid fa-trash"
                                                        style={{
                                                            position: "absolute",
                                                            right: "10px",
                                                            top: "60%",
                                                            transform: "translateY(-50%)",
                                                            color: "black",

                                                        }}
                                                    ></i></span>

                                                </>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>


                            {/* Address Proof */}
                            <div className="border mt-2 doc-styling">
                                <div className="input-box form-floating">
                                    <input
                                        type="text"
                                        placeholder="Enter Address Proof Number"
                                        className="form-control input-text form-control-sm"
                                        name="addressProofNum"
                                        value={cafDocData.addressProofNum}
                                        disabled={addressDocVerify === "Verified"}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="addressProofNum">Address Proof Number</label>
                                </div>

                                <div>
                                    <label className="select-search-label mt-1">Address Proof</label>
                                    <Select
                                        className="basic-single form-control form-control-sm p-1"
                                        classNamePrefix="select"
                                        name="addressProof"
                                        placeholder="Select Option"
                                        styles={style}
                                        value={selectAddressProof}
                                        isSearchable={false}
                                        onChange={handleSelectAddressProof}
                                        options={optionAddressProof.map((data) => ({
                                            value: data.value,
                                            label: data.label,
                                        }))}
                                    />
                                    {addressDocVerify !== "Verified" && (
                                        <>
                                            {/* Checkbox for unavailable document */}
                                            {firmType !== "6" &&
                                                <div className="form-check form-check-style">
                                                    {/* <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        value="addressProofCheck"
                                                        name="addressProofCheck"
                                                        id="addressProofCheck"
                                                        checked={isCheckboxChecked.addressProofCheck}
                                                        onChange={handleCheckboxChange}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="addressProofCheck"
                                                    >
                                                        If the document is not available. Please click on the checkbox.
                                                    </label> */}
                                                </div>
                                            }

                                            {/* Conditional input fields for date or file upload */}
                                            {(isCheckboxChecked.addressProofCheck || selectedAddressProofDate) ? (
                                                <>
                                                    <div className='date-div'>
                                                        <label htmlFor="partnerDeedDate" className="date-label-div">
                                                            Expected Document Date
                                                        </label>
                                                    </div>
                                                    <div className="input-box form-floating d-flex align-items-center position-relative"
                                                        style={{
                                                            borderBottom: "1px solid #dee0de",
                                                            width: "100%",
                                                            // maxWidth: "1500px", // Adjust as needed
                                                        }}>
                                                        <DatePicker
                                                            selected={selectedAddressProofDate}
                                                            onChange={(date) => {
                                                                setSelectedAddressProofDate(date);
                                                                const adjustedDate = new Date(
                                                                    date.getFullYear(),
                                                                    date.getMonth(),
                                                                    date.getDate() + 1 // Add one day to correct the shift
                                                                );
                                                                handleDateChange(
                                                                    { target: { value: adjustedDate.toISOString().split("T")[0] } },
                                                                    "addressProof"
                                                                );
                                                            }}
                                                            filterDate={isWeekday}
                                                            dateFormat="dd-MM-yyyy"
                                                            placeholderText="Select Date"
                                                            className="form-control input-text form-control-sm p-2"
                                                            style={{
                                                                width: "100%",
                                                                paddingRight: "40px", // Ensure space for icon
                                                                maxWidth: "1500px",
                                                            }}
                                                        />
                                                        <i
                                                            className="fa-solid fa-calendar-days position-absolute"
                                                            style={{
                                                                right: "20px",
                                                                top: "50%",
                                                                transform: "translateY(-50%)",
                                                                color: "#8b8c8b",
                                                            }}
                                                        ></i>
                                                    </div>
                                                </>
                                            ) : null}
                                            {(selectedAddressProofDate || addressDocVerify !== "Verified") && (
                                                <div
                                                    className="input-box form-floating mt-3"
                                                    style={{ position: "relative" }}
                                                >
                                                    <input
                                                        id="addressProofUpload"
                                                        disabled={!selectAddressProof?.value}
                                                        type="file"
                                                        accept="image/*,application/pdf"
                                                        onChange={(e) =>
                                                            handleFileUpload(e, "addressProof")
                                                        }
                                                        style={{ display: "none" }}
                                                    />
                                                    <input
                                                        type="text"
                                                        className="form-control input-text form-control-sm"
                                                        value={uploadedAddressFile}
                                                        readOnly
                                                        onClick={() =>
                                                            document.getElementById(
                                                                "addressProofUpload"
                                                            ).click()
                                                        }
                                                    />
                                                    <i
                                                        className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                                                        onClick={() =>
                                                            document.getElementById(
                                                                "addressProofUpload"
                                                            ).click()
                                                        }
                                                    ></i>
                                                    <label
                                                        htmlFor="addressProofUpload"
                                                        className="paperclip mt-2"
                                                    >
                                                        Upload Address Proof*
                                                    </label>
                                                </div>
                                            )}
                                        </>
                                    )}
                                    {(!uploadedAddressFile && addressDocVerify !== "Verified") &&
                                        <div className='req-color'>&nbsp;Required Field*</div>}
                                </div>

                                {/* Address Proof Document Verification Status */}
                                <div className="input-box form-floating">
                                    <div className="p-3 d-flex flex-column flex-sm-row doc-rej">
                                        <span className="mb-2 mb-sm-0">{cafDocData.addressProofDoc}</span>&nbsp;
                                        <span className="mb-sm-0 doc-rej-color">
                                            {cafDocData.addressDocRej
                                                ? `(${cafDocData.addressDocRej})`
                                                : ""}
                                        </span>
                                    </div>

                                    {addressDocVerify && (
                                        <>
                                            {addressDocVerify === "Verified" ? (
                                                <i
                                                    className="fa-solid fa-check"
                                                    style={{
                                                        position: "absolute",
                                                        right: "20px",
                                                        top: "70%",
                                                        transform: "translateY(-50%)",
                                                        color: "#77c171",
                                                    }}
                                                ></i>
                                            ) : (
                                                <>
                                                    <span><i
                                                        className="fa-solid fa-xmark"
                                                        style={{
                                                            position: "absolute",
                                                            right: "40px",
                                                            top: "60%",
                                                            transform: "translateY(-50%)",
                                                            color: "#f20d24",
                                                        }}
                                                    ></i></span>
                                                    <span className='border' style={{ cursor: "pointer" }} onClick={(e) => handleDeleteDoc(e, "addressProof")}><i
                                                        className="fa-solid fa-trash"
                                                        style={{
                                                            position: "absolute",
                                                            right: "10px",
                                                            top: "60%",
                                                            transform: "translateY(-50%)",
                                                            color: "black",

                                                        }}
                                                    ></i></span>

                                                </>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>



                        </form>


                        {/* <div className="text-center">
                            <button
                                type="button"
                                className="btn text-light bg-dark mx-auto submit-btn rounded-pill mb-4"
                                onClick={handleSubmitDocument}
                            disabled={Object.keys(isSubmitSucess).length === 0}
                            >
                                Submit Documents
                            </button>
                        </div> */}


                        {/* <div className="text-center">
                            <button
                                type="submit"
                                className="btn text-light bg-dark mx-auto submit-btn rounded-pill"
                                onClick={handleSubmitDoc}
                            >
                                Submit Document
                            </button>
                        </div> */}




                        {/* <div className="text-center mt-5">
                            <button
                                type="button"
                                className="btn text-light bg-dark mx-auto submit-btn rounded-pill mb-4"
                                onClick={handleGenerateOTPforSel}
                            >
                                Generate Otp
                            </button>
                            <button
                                type="button"
                                className="btn text-light bg-dark mx-auto submit-btn rounded-pill mb-4"
                                onClick={handleResendEmailToCust}
                            >
                                Resend Email
                            </button>
                        </div> */}

                    </div>)}



            </div>

        </>
    )
}

export default BroadbandCAFmangeNewDoc;


